(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-add-error-toast"] && !Shopify.designMode) return;
  try {
    /* Global cart-add error toast. Listens for the page-wide
     `cart:add:error` CustomEvent (PDP buy buttons, Quick Add, grid
     colour cards, any other AJAX cart-add surface) and reveals the
     toast with the Shopify-returned description when present, or a
     generic fallback otherwise. Auto-dismisses after 6000ms; user can
     dismiss earlier via the close button. */
  (function () {
    let toastTimer = null;

    function getMessage(error) {
      if (!error) return '';
      if (error.body && (error.body.description || error.body.message)) {
        return error.body.description || error.body.message;
      }
      if (typeof error.message === 'string' && error.message) {
        return error.message;
      }
      return '';
    }

    function hideToast(toast) {
      toast.removeAttribute('data-active');
      toast.setAttribute('aria-hidden', 'true');
      if (toastTimer) {
        window.clearTimeout(toastTimer);
        toastTimer = null;
      }
    }

    function showCartAddErrorToast(error, tone) {
      const toast = document.querySelector('[data-cart-add-error-toast]');
      if (!toast) return;
      const messageNode = toast.querySelector('[data-cart-add-error-toast-message]');
      if (messageNode) {
        const text = getMessage(error);
        messageNode.textContent = text || toast.dataset.fallbackMessage || '';
      }
      /* Warning tone is used for partial-success notices (e.g. some
         out-of-stock items skipped during an add-all) where the add
         still succeeded. Genuine cart-add failures pass no tone and
         keep the default error (crimson) styling and title. */
      const isWarning = tone === 'warning';
      const titleNode = toast.querySelector('[data-cart-add-error-toast-title]');
      if (titleNode) {
        titleNode.textContent = isWarning
          ? titleNode.dataset.warningTitle || titleNode.dataset.errorTitle || ''
          : titleNode.dataset.errorTitle || '';
      }
      toast.classList.toggle('cart-add-error-toast--warning', isWarning);
      toast.setAttribute('data-active', '');
      toast.setAttribute('aria-hidden', 'false');
      if (toastTimer) window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(() => hideToast(toast), 6000);
    }

    document.addEventListener('cart:add:error', (event) => {
      const detail = event.detail || {};
      showCartAddErrorToast(detail.error, detail.tone);
    });

    document.addEventListener('click', (event) => {
      const dismiss = event.target.closest('[data-cart-add-error-toast-dismiss]');
      if (!dismiss) return;
      const toast = dismiss.closest('[data-cart-add-error-toast]');
      if (toast) hideToast(toast);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-add-toast"] && !Shopify.designMode) return;
  try {
    /* Global cart-add toast. Listens for the page-wide `cart:add`
     CustomEvent (PDP buy buttons, Quick Add, grid colour cards,
     any other AJAX cart-add surface) and reveals the toast. Auto-
     dismisses after 4500ms. */
  (function () {
    let toastTimer = null;

    function showCartAddToast(payload, cappedTo) {
      const toast = document.querySelector('[data-cart-add-toast]');
      if (!toast) return;
      const titleNode = toast.querySelector('[data-cart-add-toast-title]');
      const suffixNode = toast.querySelector('[data-cart-add-toast-suffix]');
      const variantNode = toast.querySelector('[data-cart-add-toast-variant]');
      const imageNode = toast.querySelector('[data-cart-add-toast-image]');
      const productTitle = payload.product_title || payload.title || '';
      /* A capped add means the customer asked for more than the available stock
         (or MOQ ceiling) and the cart holds only what's available — the plain
         "added" copy would misrepresent that, so swap in Shopify's all-in-cart
         wording. */
      if (cappedTo != null) {
        const cappedName = productTitle;
        const template = toast.getAttribute('data-capped-template') || '';
        const message = template
          .replace('__COUNT__', String(cappedTo))
          .replace('__PRODUCT__', cappedName);
        if (titleNode) titleNode.textContent = '';
        if (suffixNode) suffixNode.textContent = message;
      } else {
        if (titleNode) titleNode.textContent = productTitle;
        if (suffixNode) suffixNode.textContent = toast.getAttribute('data-added-suffix') || '';
      }
      if (variantNode) {
        const variantTitle = payload.variant_title || '';
        if (cappedTo == null && variantTitle && variantTitle !== 'Default Title') {
          variantNode.textContent = variantTitle;
          variantNode.hidden = false;
        } else {
          variantNode.textContent = '';
          variantNode.hidden = true;
        }
      }
      if (imageNode) {
        const imageSrc = payload.image || (payload.featured_image && payload.featured_image.url);
        if (imageSrc) {
          imageNode.src = imageSrc;
          imageNode.alt = productTitle;
        }
      }
      toast.setAttribute('data-active', '');
      toast.setAttribute('aria-hidden', 'false');
      if (toastTimer) window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(() => {
        toast.removeAttribute('data-active');
        toast.setAttribute('aria-hidden', 'true');
      }, 4500);
    }

    document.addEventListener('cart:add', (event) => {
      if (event.detail && event.detail.item) {
        showCartAddToast(event.detail.item, event.detail.cappedTo);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-b2b-actions"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('cartB2bActions', () => ({
      items: [],
      init() {
        try {
          const raw = this.$root.dataset.cartItems;
          if (raw) {
            const decoder = document.createElement('textarea');
            decoder.innerHTML = raw;
            this.items = JSON.parse(decoder.value) || [];
          }
        } catch (err) {
          console.warn('[cart-b2b-actions] items JSON parse failed:', err);
          this.items = [];
        }
      },
      printOrder() {
        window.print();
      },
      /* Hand off to the shared quick-order save drawer, which owns the
         save-to-existing / create-new modals and the success toast. */
      saveToRequisition() {
        if (this.items.length === 0) return;
        document.dispatchEvent(new CustomEvent('wishlist:open-save-drawer', {
          detail: { items: this.items },
          bubbles: true,
        }));
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-item"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('cartItem', () => ({
      remove() {
        this.$dispatch('cart-item:remove', {
          key: this.$root.dataset.lineItemKey,
        });
      },
      saveForLater() {
        // Signed-in shoppers can own several wishlists, so route them
        // through the shared picker (the same one the PDP heart opens) to
        // consciously choose/create a destination list. The picker performs
        // the cart "move" (removes this line) once on close, but only after
        // a successful add — so cancelling leaves the line in place. Guests
        // keep the silent default-save + move handled by wishlist-toast's
        // `cart-item:save-for-later` bridge.
        if (this.$root.dataset.signedIn === 'true') {
          this.$dispatch('wishlist:open-picker', {
            variantId: this.$root.dataset.variantId,
            productId: this.$root.dataset.productId,
            url: this.$root.dataset.productUrl,
            title: this.$root.dataset.productTitle,
            cartLineKey: this.$root.dataset.lineItemKey,
            saveForLater: true,
          });
          return;
        }
        this.$dispatch('cart-item:save-for-later', {
          key: this.$root.dataset.lineItemKey,
          productId: this.$root.dataset.productId,
          variantId: this.$root.dataset.variantId,
          url: this.$root.dataset.productUrl,
          title: this.$root.dataset.productTitle,
        });
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-offer-banners"] && !Shopify.designMode) return;
  try {
    /* GWP eligibility guard. Server-side Liquid computes the entitlement (each
     [data-gwp-guard] element carries the verdict) but cannot mutate the cart,
     so this reconciles gift lines client-side - removing, trimming, swapping
     tiers, auto-adding a single-option gift, and dropping a gift the engine
     did not free - then re-renders the cart section and runs again until the
     cart is stable. Best-effort: if it fails, pricing stays correct
     server-side (the Function only frees gifts while the cart qualifies). */
  (() => {
    /* gwp-debug logging: trace every gift-line mutation so cart-vs-checkout
       quantity changes can be attributed. */
    const gwpLog = (...args) => {
      console.log(`[gwp-debug ${new Date().toISOString()}]`, ...args);
    };

    /* Re-entrancy lock: the guard reconciles the cart across several passes
       (auto-add -> engine applies -> truth-check -> settle), each pass
       re-triggered by `cart:section:rendered`. One pass at a time - Shopify's
       cart endpoints reject concurrent mutations. */
    let guardBusy = false;

    /* Dirty flag: a `cart:section:rendered` that arrives WHILE a
       pass is in flight is gated out by the busy check, so the state it
       reflects would go un-reconciled if that pass ends without itself
       re-rendering (e.g. rapid decrement -> re-increment: the increment's
       render is swallowed and the decrement pass no-ops after removing the
       gift, leaving the gift un-re-added until a reload). Setting this on a
       gated call, then re-running once the pass finishes, guarantees the final
       state always settles. */
    let guardDirty = false;

    /* Mirror `guardBusy` onto the cart page as `data-guard-busy` so the qty UX
       (steppers + input) can be frozen while a reconcile is in flight - a
       cart-page-level hook, so the shared quantity-selector snippet is left
       untouched. `.cart-page` survives applySectionHtml swaps (only its inner
       regions are replaced), so the attribute persists across the settling
       loop's re-renders. */
    const setGuardBusy = (busy) => {
      guardBusy = busy;
      const page = document.querySelector('.cart-page');
      if (page) page.toggleAttribute('data-guard-busy', busy);
    };

    /* Clear the busy lock at a pass's terminal points that do NOT themselves
       re-render (the no-op returns + the error catch). If a render was gated out
       mid-pass, run one trailing pass so the final cart state is reconciled.
       (The success path re-renders via applySectionHtml / cart:reconcile, which
       re-fires `cart:section:rendered`, so it clears the flag instead.) */
    const finishGuard = () => {
      setGuardBusy(false);
      if (guardDirty) {
        guardDirty = false;
        setTimeout(runGwpGuard, 0);
      }
    };

    /* Offers whose gift the engine did NOT free (a combination-conflict loss).
       Held out of auto-add until the qualifier set changes, so a lost gift
       does not re-add on every pass. Keyed by discount GID. */
    let suppressedOffers = {};

    /* Competing offers that lost the product-discount slot as OBSERVED from the
       current freed state (some competitor's gift is freed; theirs is not) -
       including selector offers that never add a gift line for the truth guard
       to catch. Display-only: recomputed from scratch every reconcile, NEVER
       persisted, and NEVER used to gate auto-add. That matters - a transient
       where a lower-value gift is freed first must not stick and suppress the
       true winner (persisting it once left the winner permanently held out). */
    let observedLosers = {};

    /* The retail-price flash on a gift line whose offer just stopped applying
       is masked at the MARKUP level, not here: a gift line keeps its
       persistent `_free_gift` property when cleared, so snippets/cart-item.liquid
       renders it `data-gift-pending-removal` (display:none) whenever it carries
       that property but is not priced free. That closes the window regardless of
       section swaps or JS timing - a client-side mask loses because
       applySectionHtml swaps in a fresh, unmasked server node before any JS runs.
       This guard's only job for those lines is the actual removal below. */

    /* Fingerprint of the non-gift (qualifier) lines. When it changes the
       shopper altered the real cart, so past combination verdicts are stale -
       clear suppressions and re-evaluate. The guard's own gift add/remove
       leaves this unchanged, so the settling loop converges. */
    let lastQualifierFingerprint = null;
    const qualifierFingerprint = (cart) =>
      (cart.items || [])
        .filter((i) => !(i.properties && i.properties._free_gift))
        .map((i) => `${i.key}:${i.quantity}`)
        .sort()
        .join('|');

    /* The combination verdict cannot be known before adding a gift and seeing
       whether the engine frees it - the theme cannot run the discount
       arbitration. Without memory, every page load re-adds (then re-drops) a
       known loser. So persist the verdicts for the session, keyed by the
       qualifier fingerprint: a real cart change invalidates the cache, a mere
       reload restores it and the loser is never re-added. */
    const SUPPRESS_STORE_KEY = 'gwpSuppressedOffers';
    try {
      const saved = JSON.parse(sessionStorage.getItem(SUPPRESS_STORE_KEY) || 'null');
      if (saved && typeof saved.fingerprint === 'string') {
        lastQualifierFingerprint = saved.fingerprint;
        suppressedOffers = saved.suppressed || {};
      }
    } catch (e) {
      /* Private mode / quota - fall back to in-memory verdicts only. */
    }
    const persistSuppressed = () => {
      try {
        sessionStorage.setItem(
          SUPPRESS_STORE_KEY,
          JSON.stringify({ fingerprint: lastQualifierFingerprint, suppressed: suppressedOffers })
        );
      } catch (e) {
        /* Ignore - persistence is a nicety, the in-memory copy still works. */
      }
    };

    /* A-priori combination-winner hint (the projection's per-market gift-value
       snapshot). Among the offers active THIS render that contend for the single
       product-discount slot (`data-competes-product-slot`) and carry a known
       gift value (`data-gift-value`, cents - only single-gift auto-add offers do),
       the engine applies only the highest-value gift, so the strictly lower ones
       are predicted losers and get held out of auto-add - no first-encounter
       add-then-drop churn. Stateless: recomputed every pass from the DOM, never
       persisted, so it cannot poison the observed truth verdicts. Only a UNIQUE
       maximum predicts; a tie or any $0/unknown value yields no prediction and
       those offers fall through to add -> observe -> drop, where the truth guard
       (`suppressedOffers`) is the authority. */
    const predictedLosers = () => {
      const losers = {};
      const contenders = Array.from(
        document.querySelectorAll('[data-competes-product-slot="true"]')
      ).filter((el) => {
        const active = el.dataset.eligible === 'true' || Number(el.dataset.entitled) > 0;
        const value = Number(el.dataset.giftValue);
        return active && Number.isFinite(value) && value > 0;
      });
      if (contenders.length < 2) return losers;
      const values = contenders.map((el) => Number(el.dataset.giftValue));
      const maxValue = Math.max(...values);
      if (values.filter((value) => value === maxValue).length !== 1) return losers;
      contenders.forEach((el) => {
        const gid = el.dataset.discountGid || el.dataset.source;
        if (gid && Number(el.dataset.giftValue) < maxValue) losers[gid] = true;
      });
      return losers;
    };

    /* Single-option auto-add resolution: a marker range cannot be enumerated
       in Liquid, so each guard carries a page-1 tiles URL (`data-gift-fetch`)
       and the option count is observed client-side: exactly ONE tile, ZERO
       sold-out stubs (a matched variant merely out of stock still makes the
       range multi-option - forcing its lone in-stock sibling on the shopper is
       not "the only gift") and no next page means a single-option range, whose
       variant id feeds the auto-add path. Successful resolutions are cached per
       URL for the page's lifetime - the settling loop must not refetch - but a
       failed fetch is NOT cached, so a transient blip retries on the next
       guard pass instead of suppressing the auto-add all page long. */
    const singleOptionCache = {};
    const resolveSingleOption = (url) => {
      if (!url) return Promise.resolve('');
      if (singleOptionCache[url] !== undefined) return Promise.resolve(singleOptionCache[url]);
      /* No Accept: application/json - on `?sections=` requests that header
         makes Shopify return the page's own JSON instead of the sections
         payload (same rule as the selector's tiles fetch). */
      return fetch(url, { credentials: 'same-origin' })
        .then((res) => {
          if (!res.ok) throw new Error(`Gift tiles request failed (${res.status})`);
          return res.json();
        })
        .then((payload) => {
          let variant = '';
          const html = payload && payload['product-picker-tiles'];
          if (html) {
            const template = document.createElement('template');
            template.innerHTML = html;
            const wrapper = template.content.querySelector('[data-picker-tiles]');
            const tiles = wrapper ? wrapper.querySelectorAll('[data-picker-tile]') : [];
            const stubs = wrapper ? wrapper.querySelectorAll('[data-picker-tile-unavailable]') : [];
            if (wrapper && wrapper.dataset.hasNext !== 'true' && tiles.length === 1 && stubs.length === 0) {
              variant = tiles[0].dataset.variantId || '';
            }
          }
          singleOptionCache[url] = variant;
          return variant;
        })
        .catch(() => '');
    };

    /* Held out of AUTO-ADD when the engine dropped the gift (observed truth,
       persisted) OR the offer is a predicted combination loser. Deliberately
       excludes observedLosers - that is a display-only inference and must never
       stop the true winner's gift from being auto-added. */
    const isHeldOut = (gid, predicted) => Boolean(suppressedOffers[gid] || predicted[gid]);

    /* Conflict notices (opt-in via the cart section setting): reveal a "not
       combinable" banner for every held-out offer and hide that offer's earned
       card + progress bar, so a combination loser reads as intentional instead of
       silently vanishing. When the setting is off no notice elements exist, so
       that part is a no-op. Driven by truth + prediction, run every render. */
    const syncConflictNotices = () => {
      const predicted = predictedLosers();
      /* Display hides a truth loser, a predicted loser, OR an observed slot loser
         (its card must not linger once a competitor's gift is freed). Broader
         than the auto-add gate on purpose - observedLosers never blocks a win. */
      const hiddenForDisplay = (gid) =>
        Boolean(suppressedOffers[gid] || predicted[gid] || observedLosers[gid]);
      document.querySelectorAll('[data-offer-banner][data-discount-gid]').forEach((el) => {
        if (hiddenForDisplay(el.dataset.discountGid)) {
          el.setAttribute('data-suppressed', '');
        } else {
          el.removeAttribute('data-suppressed');
        }
      });
      /* A hidden offer's spend-progress bar (in the cart summary) is hidden too:
         its gift is not freed, so a "complete" bar would tell the shopper they
         earned a gift they did not get. */
      document.querySelectorAll('[data-progress-bar][data-discount-gid]').forEach((el) => {
        if (hiddenForDisplay(el.dataset.discountGid)) {
          el.setAttribute('data-suppressed', '');
        } else {
          el.removeAttribute('data-suppressed');
        }
      });
      document.querySelectorAll('[data-conflict-notice][data-discount-gid]').forEach((el) => {
        el.hidden = !hiddenForDisplay(el.dataset.discountGid);
      });
    };

    /* Reserved-height skeleton for a committed single-option auto-add.
       Inserted ONLY once the guard commits to adding the gift (eligibility
       confirmed, single variant resolved, not held out) so it can never show on
       a non-eligible / unconfirmed cart. It reserves the incoming gift line's
       height so the real line lands with no content-layout-shift, and shimmers
       as a loading affordance. A fixed-height skeleton - NOT an optimistic real
       line - so it cannot mismatch the server-rendered locked gift line's
       price / badge / "Change item". */
    const GIFT_PLACEHOLDER_ID = 'gwp-gift-placeholder';
    const insertGiftPlaceholder = () => {
      if (document.getElementById(GIFT_PLACEHOLDER_ID)) return;
      const list = document.querySelector('.cart-page__list');
      if (!list) return;
      const li = document.createElement('li');
      li.id = GIFT_PLACEHOLDER_ID;
      li.className = 'cart-page__row';
      li.setAttribute('aria-hidden', 'true');
      /* Detached node, client-only loading affordance (not server-constructable
         content) - innerHTML here is safe and readable. */
      li.innerHTML =
        '<div class="cart-item gwp-gift-skeleton">' +
        '<div class="gwp-gift-skeleton__media"></div>' +
        '<div class="gwp-gift-skeleton__body">' +
        '<span class="gwp-gift-skeleton__bar"></span>' +
        '<span class="gwp-gift-skeleton__bar gwp-gift-skeleton__bar--short"></span>' +
        '</div>' +
        '</div>';
      /* Prepend, not append: Shopify renders the newest cart line first, and the
         auto-added gift is the newest line, so the real gift lands at the TOP of
         the list. Reserving the height there (not at the bottom) is what
         actually prevents the shift. */
      list.prepend(li);
    };
    const removeGiftPlaceholder = () => {
      const el = document.getElementById(GIFT_PLACEHOLDER_ID);
      if (el) el.remove();
    };

    const runGwpGuard = () => {
      syncConflictNotices();
      /* Clear any stale auto-add skeleton from a prior pass. The success
         path already discards it with the items container on the reconcile
         re-render; this covers any extra cart:section:rendered before that
         re-render lands. */
      removeGiftPlaceholder();
      if (guardBusy) {
        /* A pass is running; remember that the DOM changed so we re-run once it
           finishes (see guardDirty). */
        guardDirty = true;
        return;
      }
      const gwpGuards = Array.from(document.querySelectorAll('[data-gwp-guard]'));
      if (gwpGuards.length === 0) return;
      setGuardBusy(true);

      /* Every live GWP offer's gid. A stamped gift line whose source is one
         of these is valid; anything else is orphaned. A bare cleanup guard
         (no live GWP offer) has an empty gid. */
      const gwpGids = {};
      gwpGuards.forEach((g) => {
        if (g.dataset.discountGid) gwpGids[g.dataset.discountGid] = true;
      });

      /* Predicted combination losers for this render - held out of auto-add below
         (computed once; the DOM does not change mid-reconcile). */
      const predicted = predictedLosers();

      gwpLog('guard start', {
        gwpGuards: gwpGuards.map((g) => ({
          gid: g.dataset.discountGid || '',
          eligible: g.dataset.eligible === 'true',
          allowance: g.dataset.allowance,
          autoVariant: g.dataset.autoVariant || '',
          giftFetch: g.dataset.giftFetch || '',
          activeTier: g.dataset.activeTier || '',
        })),
      });

      /* Resolve single-option auto-adds BEFORE reading the cart, so the
         per-guard reconciliation below sees a settled autoVariant. */
      const optionResolutions = [];
      gwpGuards.forEach((g) => {
        if (g.dataset.eligible === 'true' && !g.dataset.autoVariant && g.dataset.giftFetch) {
          optionResolutions.push(
            resolveSingleOption(g.dataset.giftFetch).then((variant) => {
              g.dataset.autoVariant = variant;
            })
          );
        }
      });

      /* The option resolutions (single-option tiles fetch) and the cart read are
         independent, so run them CONCURRENTLY rather than chaining the cart read
         after the tiles fetch - shaving one round-trip off the auto-add path.
         autoVariant is still settled here because each resolution writes
         it back onto its guard's dataset in its own `.then`, awaited by the inner
         Promise.all; the cart JSON arrives as the second tuple slot. */
      Promise.all([
        Promise.all(optionResolutions),
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((res) => {
          if (!res.ok) throw new Error(`Cart read failed (${res.status})`);
          return res.json();
        }),
      ])
        .then(([, cart]) => {
          gwpLog('guard cart snapshot', JSON.stringify((cart.items || []).map((item) => ({
            key: item.key,
            variant_id: item.variant_id,
            quantity: item.quantity,
            title: item.title,
            final_line_price: item.final_line_price,
            properties: item.properties,
            discounts: item.line_level_discount_allocations,
          }))));

          /* Qualifier-set change clears combination suppressions - re-evaluate
             which offers win. Gift-only churn keeps the fingerprint stable, so
             the settling loop does not wipe verdicts mid-reconcile. */
          const fp = qualifierFingerprint(cart);
          if (fp !== lastQualifierFingerprint) {
            suppressedOffers = {};
            lastQualifierFingerprint = fp;
            persistSuppressed();
          }

          /* Every stamped gift line the guard manages - GWP gifts AND the
             single-option BXGY gifts the guard auto-adds. A gift line carries
             the `_free_gift` property; its `_free_gift_source` ties it to the
             owning offer's guard. Multi-option BXGY picks and customer-added Y
             items carry no `_free_gift`, so they never enter this set and stay
             ordinary lines the Function prices by itself. */
          const allGiftLines = (cart.items || []).filter(
            (item) => item.properties && item.properties._free_gift
          );
          /* Reveal the earned card: only for a genuine multi-option pick
             (eligible, no resolved autoVariant, not held out). A single-option
             tier keeps its card hidden - the guard auto-adds its gift below and
             the next render suppresses the card via `gift_applied` - so the
             "you've earnt a gift" banner and the gift line land together instead
             of the banner flashing ahead. Runs before the early return so a
             multi-option offer awaiting a pick (no gift line yet) still reveals.
             autoVariant is settled here (option resolutions were awaited). */
          gwpGuards.forEach((guard) => {
            const gid = guard.dataset.discountGid || '';
            if (!gid) return;
            const card = document.querySelector(`[data-offer-banner][data-discount-gid="${gid}"]`);
            if (!card) return;
            if (guard.dataset.eligible === 'true' && !guard.dataset.autoVariant && !isHeldOut(gid, predicted)) {
              card.removeAttribute('data-gift-pending');
            }
          });

          /* Recompute observed slot losers from scratch each pass (display-only,
             not persisted) so a stale or transient verdict can never stick. */
          observedLosers = {};
          const gwpAutoNeeded = gwpGuards.some(
            (g) => g.dataset.eligible === 'true' && g.dataset.autoVariant
          );

          /* A cleanup guard renders even with NO live offer, so orphan
             cleanup below still runs after an offer ends, pauses, or expires. */

          /* Nothing to remove/trim AND nothing to auto-add: done. */
          if (allGiftLines.length === 0 && !gwpAutoNeeded) {
            finishGuard();
            return null;
          }

          const changes = [];
          const additions = [];

          /* Units the engine froze on UNSTAMPED lines (customer-added Y
             items, "add 3, cheapest free"), counted per offer via the
             discount-application title (the Function's candidate message,
             carried on each guard as data-app-title). These consume the
             offer's entitlement exactly like a stamped gift, so every
             trim / auto-add below works from the REMAINDER - without this
             the guard would add a stamped gift on top of an organic free,
             silently swapping the customer's own unit back to full price.
             JS mirror of snippets/discount-freed-units.liquid (minus the
             scope check - variant metafields are not client-readable) and
             must stay in sync with it: ROUNDED division, because a prior
             combining discount makes the allocation smaller than the freed
             units' original price and a floor would drop to 0. */
          const organicFreedUnits = (appTitle) => {
            if (!appTitle) return 0;
            let units = 0;
            (cart.items || []).forEach((item) => {
              if (item.properties && item.properties._free_gift) return;
              if (!item.original_price) return;
              (item.line_level_discount_allocations || []).forEach((alloc) => {
                const application = alloc.discount_application || {};
                if (application.title === appTitle) {
                  units += Math.round(alloc.amount / item.original_price);
                }
              });
            });
            return units;
          };

          /* GWP reconciliation - one pass per live GWP guard. Each guard
             manages only its offer's gift lines (matched by
             _free_gift_source == its gid); unstamped lines that carry no
             source are claimed by the first guard only, so two guards never
             both process the same line. */
          gwpGuards.forEach((guard, guardIndex) => {
            const eligible = guard.dataset.eligible === 'true';
            const grantedAllowance = parseInt(guard.dataset.allowance, 10) || 0;
            const allowance = Math.max(0, grantedAllowance - organicFreedUnits(guard.dataset.appTitle));
            const autoVariant = guard.dataset.autoVariant || '';
            const gwpGid = guard.dataset.discountGid || '';
            const claimsUnstamped = guardIndex === 0;
            const giftLines = allGiftLines.filter((line) => {
              const source = line.properties._free_gift_source;
              if (source) return source === gwpGid;
              return claimsUnstamped;
            });

            if (!eligible) {
              giftLines.forEach((line) => {
                changes.push({ id: line.key, quantity: 0 });
              });
            } else if (autoVariant) {
              /* Single-option active tier (upgrade model): exactly one gift
                 line - the auto variant at the full allowance. Everything else
                 (previous tiers' gifts, stale selections) is swapped out. Add
                 is best-effort: if the gift is unavailable the catch below
                 no-ops and pricing stays correct server-side. */
              let autoLine = null;
              giftLines.forEach((line) => {
                if (!autoLine && String(line.variant_id) === autoVariant) {
                  autoLine = line;
                  return;
                }
                changes.push({ id: line.key, quantity: 0 });
              });
              if (autoLine) {
                if (autoLine.quantity !== allowance) {
                  changes.push({ id: autoLine.key, quantity: allowance });
                }
              } else if (allowance > 0 && !isHeldOut(gwpGid, predicted)) {
                const giftProperties = { _free_gift: 'true' };
                if (guard.dataset.discountType) {
                  giftProperties._free_gift_type = guard.dataset.discountType;
                }
                if (guard.dataset.discountGid) {
                  giftProperties._free_gift_source = guard.dataset.discountGid;
                }
                if (guard.dataset.activeTier) {
                  giftProperties._free_gift_tier = guard.dataset.activeTier;
                }
                /* Auto-add path: the gift is a single-option mandatory reward.
                   The lock flag lets the cart line hide its remove + change
                   controls. */
                giftProperties._free_gift_locked = 'true';
                additions.push({ id: Number(autoVariant), quantity: allowance, properties: giftProperties });
                /* Commit point: eligibility + single variant are confirmed and
                   the add is queued, so reserve the gift line's height now to
                   kill the insert CLS. Never reached for a non-eligible
                   cart or a held-out/multi-option offer. */
                insertGiftPlaceholder();
              }
            } else {
              /* Multi-option range: drop gift lines from OTHER tiers (the
                 swap on tier change - lines are stamped `_free_gift_tier`
                 when added, so the stamp, not a variant list, is the tier
                 identity), then trim what's left to the allowance. A marker
                 range's variant membership cannot be re-verified here;
                 the Function stays authoritative and a
                 stale line the engine stops freeing is dropped by the truth
                 guard below. */
              const activeTier = guard.dataset.activeTier || '';
              let remaining = allowance;
              giftLines.forEach((line) => {
                const lineTier = line.properties._free_gift_tier;
                const lineTierKey = lineTier == null ? '' : String(lineTier);
                if (activeTier !== '' && lineTierKey !== activeTier) {
                  changes.push({ id: line.key, quantity: 0 });
                  return;
                }
                const keep = Math.min(line.quantity, Math.max(remaining, 0));
                remaining -= keep;
                if (keep !== line.quantity) {
                  changes.push({ id: line.key, quantity: keep });
                }
              });
            }
          });

          /* Orphaned gift lines: ANY stamped line (`_free_gift_source`) whose
             source is not a live GWP guard's gid - the offer ended, paused,
             expired, or was reconfigured - is removed, so a dead offer's
             "free" line can't sit in the cart at $0.00 display while checkout
             charges full price. Unstamped lines that carry no source belong
             to the GWP branch above. (BXGY-typed stamps are excluded
             from allGiftLines up top.) */
          allGiftLines.forEach((line) => {
            const source = line.properties._free_gift_source;
            if (!source) return;
            if (gwpGids[source]) return;
            changes.push({ id: line.key, quantity: 0 });
          });

          /* Truth guard: a held gift the engine did NOT free (final_line_price
             != 0) lost a combination conflict - best-available-price gave the
             product-discount slot to another offer. Remove it and suppress its
             offer so this pass (and the next, until the qualifier set changes)
             does not re-add it. A freed gift (0) stays. */
          allGiftLines.forEach((line) => {
            if (line.final_line_price === 0) return;
            const zeroedAlready = changes.some(
              (c) => c.id === line.key && c.quantity === 0
            );
            if (zeroedAlready) return;
            changes.push({ id: line.key, quantity: 0 });
            const src = line.properties._free_gift_source;
            if (src) suppressedOffers[src] = true;
            gwpLog('truth-guard drop (engine did not free)', { key: line.key, src, price: line.final_line_price });
          });

          /* Observed slot loss (display-only, into observedLosers reset above -
             NOT the persisted suppressedOffers): once a NON-combining competitor's
             gift IS freed (`competesForProductSlot`), the engine gave it the single
             product-discount slot. Nothing can combine with a non-combining winner,
             so EVERY other still-earned gift offer that is not itself freed has
             lost - whether or not IT opted into combining. Flag them all so a
             loser's "earned" card / progress ticker cannot linger, including a
             selector offer that never auto-adds a gift line for the truth guard to
             catch (e.g. a `competesForProductSlot: false` multi-select GWP that
             still loses to a non-combining Derwent/Cart-Spend gift). Derived from
             the engine's actual verdict (the freed line); recomputed every pass so
             a transient freed-loser self-corrects and never stalls the true winner.
             A genuinely-combining offer whose gift the engine DID free lands in
             freedBySource and is skipped by the `!freedBySource` test below. */
          const competesByGid = {};
          gwpGuards.forEach((g) => {
            const gid = g.dataset.discountGid;
            if (gid) competesByGid[gid] = g.dataset.competesProductSlot === 'true';
          });
          const freedBySource = {};
          allGiftLines.forEach((line) => {
            const src = line.properties._free_gift_source;
            if (src && line.final_line_price === 0) freedBySource[src] = true;
          });
          /* Trigger stays gated on a NON-combining winner being freed: only then is
             the slot exclusively taken. A combining winner (competesForProductSlot
             false) would let others share, so its freed gift must NOT hide them. */
          const competingWinnerFreed = Object.keys(freedBySource).some((src) => competesByGid[src]);
          if (competingWinnerFreed) {
            gwpGuards.forEach((g) => {
              const gid = g.dataset.discountGid;
              const earned = g.dataset.eligible === 'true';
              if (gid && earned && !freedBySource[gid]) {
                observedLosers[gid] = true;
              }
            });
          }

          /* Remember this pass's verdicts so a reload does not re-add a known
             loser. Written after both the qualifier-reset and the
             truth-guard so the cache reflects the settled decision. */
          persistSuppressed();

          /* Re-apply the display now suppressions are final. The top-of-pass
             sync ran against the PRE-reconcile set (and a qualifier change had
             just cleared it), so a no-op pass - e.g. the winner's gift is
             already freed and only the loser needs hiding after a quantity
             change - would otherwise leave the loser's card on screen until the
             next render/reload. */
          syncConflictNotices();

          if (changes.length === 0 && additions.length === 0) {
            finishGuard();
            gwpLog('guard no-op (cart conforms)');
            return null;
          }

          gwpLog('guard WILL MUTATE', { changes, additions });

          /* Cart section id (the SAME id fetchSection uses), read from the cart
             section wrapper so it is never hardcoded. Used by option B below to
             fold the section render into the auto-add's add.js and swap from its
             response - skipping the separate fetchSection round-trip. */
          const cartRoot = document.querySelector('[x-data="cartPage"]');
          const sectionId =
            (cartRoot && cartRoot.closest('[data-section-id]') && cartRoot.closest('[data-section-id]').dataset.sectionId) || '';
          let addSectionHtml = null;

          /* Sequential - Shopify's cart endpoints reject concurrent mutations
             on the same cart. */
          let queue = Promise.resolve();
          changes.forEach((change) => {
            queue = queue.then(() => {
              gwpLog('guard change.js ->', change);
              return fetch('/cart/change.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(change),
              }).then((res) => {
                if (!res.ok) throw new Error(`Cart change failed (${res.status})`);
                return res.json();
              });
            });
          });
          if (additions.length) {
            queue = queue.then(() => {
              gwpLog('guard add.js ->', additions);
              /* Fold the section render into the add (option B): add.js is
                 the LAST mutation in the queue, so its `sections` response
                 reflects the final post-change + post-add cart - swap from it
                 and skip the separate fetchSection round-trip. */
              const body = { items: additions };
              if (sectionId) body.sections = sectionId;
              return fetch('/cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(body),
              }).then((res) => {
                if (!res.ok) throw new Error(`Cart add failed (${res.status})`);
                return res.json();
              }).then((data) => {
                if (data && data.sections && sectionId) {
                  addSectionHtml = data.sections[sectionId] || null;
                }
                return data;
              });
            });
          }
          return queue.then(() => {
            /* Clear busy; the swap / cart:reconcile below re-fires
               `cart:section:rendered`, and that fresh pass reads the final DOM
               (any gated-out state is now rendered), so drop the dirty flag
               rather than schedule a redundant trailing pass. */
            setGuardBusy(false);
            guardDirty = false;
            /* Option B fast path: swap directly from the add response's section
               HTML - no separate fetchSection. `applySectionHtml` replaces
               `.cart-page__items` (discarding the reserved placeholder)
               + `.cart-page__aside`, and re-dispatches `cart:section:rendered`,
               so the settling loop keeps running. Reached via `Alpine.$data` on
               the cart component root - a deliberate cross-boundary call because
               `applySectionHtml` lives on the `cartPage` component, and routing
               through `cart:reconcile` would re-run the fetchSection we are
               eliminating. */
            const cartComp = cartRoot && window.Alpine ? Alpine.$data(cartRoot) : null;
            if (addSectionHtml && cartComp && typeof cartComp.applySectionHtml === 'function') {
              gwpLog('guard mutations done -> swap from add response (option B)');
              cartComp.applySectionHtml(addSectionHtml);
              /* add.js does not carry the authoritative item_count to the
                 header, and we skipped the /cart.js fetchSection did, so
                 nudge the bag badge to re-sync (header.liquid re-fetches /cart.js
                 on this event). NOT `cart:add` - that fires the "Added to cart"
                 toast on the silent gift. */
              window.dispatchEvent(new CustomEvent('cart:updated'));
              return;
            }
            /* Robust fallback: no add, no section HTML, or the component is
               unavailable - keep today's behaviour exactly (dispatch
               `cart:reconcile`, which fetchSection + swaps). Never worse than
               before. Dispatch from a guard element - a descendant of the cart
               component's x-data root - so the bubbling event reaches its
               listener. (`.cart-page` is an ANCESTOR of that root, so an event
               there would bubble the wrong way.) */
            gwpLog('guard mutations done -> re-render + reconcile (fallback)');
            const host = document.querySelector('[data-gwp-guard]');
            if (host) {
              host.dispatchEvent(new CustomEvent('cart:reconcile', { bubbles: true }));
            } else {
              window.location.reload();
            }
          });
        })
        .catch((error) => {
          /* Best-effort guard - see comment above. No re-render fires here, so
             finishGuard clears the lock AND runs a trailing pass if a render was
             gated out mid-pass. */
          finishGuard();
          gwpLog('guard ERROR (no-op)', error && error.message);
          /* No re-render fires on the failure path, so a committed-add skeleton
             would otherwise linger - tear it down explicitly. */
          removeGiftPlaceholder();
          /* The single-vs-multi decision never settled, so reveal every hidden
             earned card as a fail-safe: auto-add did not run either, so
             there is no flash risk, and a shopper can still open the selector to
             claim a multi-option gift rather than face a permanently hidden card. */
          document.querySelectorAll('[data-offer-banner][data-gift-pending]').forEach((card) => {
            card.removeAttribute('data-gift-pending');
          });
        });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runGwpGuard);
    } else {
      runGwpGuard();
    }

    /* Re-run after the cart section re-renders without a full page load - a
       quantity change, a line removal, or the guard's own `cart:reconcile`.
       The cart component swaps the cart HTML and then dispatches
       `cart:section:rendered` AFTER the swap, so the [data-gwp-guard] verdicts
       are fresh. (`cart:updated` fires BEFORE the swap, so it is not used
       here.) This is what drives the settling loop - the re-entrancy lock
       stops overlapping passes and the no-op branch ends it. */
    window.addEventListener('cart:section:rendered', runGwpGuard);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-save-all-to-wishlist"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('cartSaveAllToWishlist', () => ({
      saving: false,
      idleLabel: 'Save all to wishlist',
      savingLabel: 'Saving...',
      init() {
        const el = this.$root;
        this.idleLabel = el.dataset.idleLabel || this.idleLabel;
        this.savingLabel = el.dataset.savingLabel || this.savingLabel;
      },
      async saveAll() {
        if (this.saving) return;
        if (!window.EckList) return;
        const nodes = document.querySelectorAll('[data-line-item-key][data-variant-id]');
        if (nodes.length === 0) return;
        this.saving = true;
        try {
          const defaultList = await window.EckList.getDefaultList({ createIfMissing: 'Favourites' });
          if (!defaultList || !defaultList.lid) return;
          // Build a set of variant ids already in the target list so we
          // don't accumulate duplicates on repeat save-all clicks.
          const existing = new Set(
            (defaultList.listcontents || []).map((it) => Number(it.epi)).filter(Boolean)
          );
          // Also dedupe within the current cart-line set so multiple
          // lines that share a variant only add once.
          const seen = new Set();
          let added = 0;
          for (const node of nodes) {
            const variantId = Number(node.dataset.variantId);
            const productId = Number(node.dataset.productId);
            const url = String(node.dataset.productUrl || '');
            if (!variantId || !productId || !url) continue;
            if (existing.has(variantId) || seen.has(variantId)) continue;
            seen.add(variantId);
            try {
              await window.EckList.addProduct(defaultList.lid, { variantId, productId, url });
              added++;
            } catch (e) { /* individual failures don't stop the batch */ }
          }
          document.dispatchEvent(new CustomEvent('wishlist:toast', {
            detail: {
              kind: 'added',
              lid: defaultList.lid,
              lname: defaultList.lname,
              item: { dt: added === 1 ? '1 item' : (added + ' items') },
            },
            bubbles: true,
          }));
        } catch (err) {
          console.warn('[cart-save-all-to-wishlist] failed:', err);
        } finally {
          this.saving = false;
        }
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["discount-projections"] && !Shopify.designMode) return;
  try {
    /* Variant-level gate toggle. Placements rendered with
     [data-discount-variant-gate] apply to specific variants only
     (variant-gated applicable-products lists); the picker dispatches a
     bubbling variant:change with the matched variant payload, and each
     gated element shows only while the selected variant is in its list.
     Inverse-gated elements (the plain-price fallback) do the opposite.
     Only PDP main-product surfaces render these attributes, so a
     document-level listener is safe. */
  (function () {
    function toggleVariantGates(variantId) {
      /* null = deselection: forward placements return to their any-visible
         landing state - shown when the element carries the landing marker
         (some visible variant qualifies), hidden otherwise; inverse
         placements (the plain-price fallback) show. */
      var id = variantId === null ? null : String(variantId);
      document
        .querySelectorAll('[data-discount-variant-gate]')
        .forEach(function (el) {
          if (id === null) {
            el.hidden = !el.hasAttribute('data-discount-variant-gate-landing');
            return;
          }
          var ids = (el.getAttribute('data-discount-variant-gate') || '').split(',');
          el.hidden = ids.indexOf(id) === -1;
        });
      document
        .querySelectorAll('[data-discount-variant-gate-inverse]')
        .forEach(function (el) {
          var ids = (el.getAttribute('data-discount-variant-gate-inverse') || '').split(',');
          el.hidden = id !== null && ids.indexOf(id) !== -1;
        });
    }

    document.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      toggleVariantGates(variant && variant.id ? variant.id : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    const fire = (dialog, name) => dialog.dispatchEvent(new CustomEvent(name, { bubbles: true }));

    const openDrawer = (dialog) => {
      if (!dialog || dialog.open) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      fire(dialog, 'drawer:open');
    };

    const closeDrawer = (dialog) => {
      if (!dialog || !dialog.open) return;
      dialog.close();
      fire(dialog, 'drawer:close');
    };

    const isBackdropClick = (dialog, event) => {
      const panel = dialog.querySelector('.drawer__panel');
      if (!panel) return false;
      const r = panel.getBoundingClientRect();
      return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-drawer-open]');
      if (opener) {
        event.preventDefault();
        openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')));
        return;
      }
      const closer = event.target.closest('[data-drawer-close]');
      if (closer) {
        event.preventDefault();
        closeDrawer(closer.closest('dialog[data-drawer]'));
        return;
      }
      const dialog = event.target;
      if (dialog.tagName === 'DIALOG' && dialog.hasAttribute('data-drawer') && isBackdropClick(dialog, event)) {
        closeDrawer(dialog);
      }
    });

    document.addEventListener('cancel', (event) => {
      const dialog = event.target;
      if (dialog?.matches?.('dialog[data-drawer]')) fire(dialog, 'drawer:close');
    }, true);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dropdown"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('dropdown', () => ({
      hasValue: false,
      valueLabel: '',
      emptyResults: false,
      searchTerm: '',
      init() {
        this.valueLabel = this.$root.dataset.initialLabel || '';
        const initialValue = this.$refs.hidden.value;
        this.hasValue = !!initialValue;
        if (initialValue) {
          const option = this.$root.querySelector(
            `.dropdown__option[data-dropdown-value="${CSS.escape(initialValue)}"]`
          );
          if (option) option.setAttribute('data-selected', '');
        }
      },
      selectFromEvent(event) {
        const option = event.target.closest('.dropdown__option');
        if (!option) return;
        const value = option.dataset.dropdownValue || '';
        const label = option.textContent.trim();
        this.$refs.hidden.value = value;
        // Empty value = the option represents "no selection / default"
        // (e.g. an "All" reset option). Drop the floating value label so
        // the trigger stays in placeholder mode and the label doesn't
        // visually stack on top of itself.
        this.valueLabel = value ? label : '';
        this.hasValue = !!value;
        this.$root.querySelectorAll('.dropdown__option').forEach((opt) => {
          opt.toggleAttribute('data-selected', opt === option);
        });
        this.close();
        this.$dispatch('dropdown:change', { value, label });
      },
      filter() {
        const lowered = this.searchTerm.trim().toLowerCase();
        let visible = 0;
        this.$root.querySelectorAll('.dropdown__option').forEach((opt) => {
          const match = !lowered || opt.textContent.toLowerCase().includes(lowered);
          opt.hidden = !match;
          if (match) visible += 1;
        });
        this.emptyResults = visible === 0;
      },
      clearSearch() {
        this.searchTerm = '';
        this.filter();
        if (this.$refs.search) this.$refs.search.focus();
      },
      close() {
        this.$refs.details.open = false;
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["file-upload"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('fileUpload', () => ({
      dragover: false,
      files: [],
      onSelect() {
        this.rebuildFromInput();
        this.$dispatch('file-upload:change', {
          files: this.$refs.control.files,
          name: this.$refs.control.name,
        });
      },
      onDrop(event) {
        this.dragover = false;
        const dropped = event.dataTransfer?.files;
        if (!dropped || !this.$refs.control) return;
        this.$refs.control.files = dropped;
        this.onSelect();
      },
      remove(index) {
        this.files.splice(index, 1);
        this.$dispatch('file-upload:remove', {
          index,
          name: this.$refs.control?.name,
        });
      },
      rebuildFromInput() {
        const inputFiles = this.$refs.control.files;
        this.files = Array.from(inputFiles).map((file) => ({
          name: file.name,
          size: `${(file.size / 1024).toFixed(0)} KB`,
          previewUrl: file.type.startsWith('image/') ? URL.createObjectURL(file) : null,
        }));
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filter-group"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__filterGroupPriceSliderBound) return;
    window.__filterGroupPriceSliderBound = true;

    let drag = null;

    function clamp(v, lo, hi) {
      return Math.max(lo, Math.min(hi, v));
    }

    function readDollars(input, fallback) {
      const n = parseFloat(input.value);
      return Number.isFinite(n) ? n : fallback;
    }

    function paint(slider, minDollars, maxDollars, rangeMax) {
      const minPct = rangeMax > 0 ? clamp((minDollars / rangeMax) * 100, 0, 100) : 0;
      const maxPct = rangeMax > 0 ? clamp((maxDollars / rangeMax) * 100, 0, 100) : 100;
      const handles = slider.querySelectorAll('.filter-group__price-slider-handle');
      const track = slider.querySelector('.filter-group__price-slider-track-active');
      handles[0].style.setProperty('--pos', minPct + '%');
      handles[1].style.setProperty('--pos', maxPct + '%');
      if (track) {
        track.style.setProperty('--min', minPct + '%');
        track.style.setProperty('--max', maxPct + '%');
      }
    }

    function beginDrag(event) {
      const handle = event.target.closest('.filter-group__price-slider-handle');
      if (!handle) return;
      const slider = handle.closest('[data-price-slider]');
      if (!slider) return;
      const root = slider.parentElement;
      const minInput = root.querySelector('[data-price-input="min"]');
      const maxInput = root.querySelector('[data-price-input="max"]');
      if (!minInput || !maxInput) return;
      const rangeMax = parseFloat(slider.dataset.rangeMax);
      if (!Number.isFinite(rangeMax) || rangeMax <= 0) return;

      drag = {
        slider,
        rangeMax,
        minInput,
        maxInput,
        which: handle.dataset.priceHandle,
        rect: slider.getBoundingClientRect(),
        form: slider.closest('[data-plp-filter-form]'),
        changed: false,
      };
      handle.dataset.dragging = 'true';
      handle.setPointerCapture(event.pointerId);
      event.preventDefault();
    }

    function moveDrag(event) {
      if (!drag) return;
      const { rect, rangeMax, minInput, maxInput, which } = drag;
      const pct = clamp(((event.clientX - rect.left) / rect.width) * 100, 0, 100);
      const value = Math.round((pct / 100) * rangeMax);
      let minVal = readDollars(minInput, 0);
      let maxVal = readDollars(maxInput, rangeMax);

      if (which === 'min') {
        minVal = clamp(value, 0, maxVal);
        if (minInput.value !== String(minVal)) {
          minInput.value = minVal;
          drag.changed = true;
        }
      } else {
        maxVal = clamp(value, minVal, rangeMax);
        if (maxInput.value !== String(maxVal)) {
          maxInput.value = maxVal;
          drag.changed = true;
        }
      }
      paint(drag.slider, minVal, maxVal, rangeMax);
    }

    function endDrag(event) {
      if (!drag) return;
      const handle = drag.slider.querySelector(`[data-price-handle="${drag.which}"]`);
      if (handle) {
        try { handle.releasePointerCapture(event.pointerId); } catch (_) {}
        delete handle.dataset.dragging;
      }
      const { form, changed } = drag;
      drag = null;
      if (changed && form) {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }
    }

    document.addEventListener('pointerdown', beginDrag);
    document.addEventListener('pointermove', moveDrag);
    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gwp-cart-offer"] && !Shopify.designMode) return;
  try {
    /* GWP eligibility guard. Server-side Liquid computes the entitlement (the
     [data-gwp-guard] element carries the verdict) but cannot mutate the
     cart, so this reconciles gift lines client-side - removing, trimming,
     swapping tiers, and auto-adding a single-option tier's gift - then
     reloads. Runs once per page load; after the reload the cart conforms,
     so it no-ops. Best-effort: if it fails, pricing is still correct
     server-side (the GWP Function only frees gifts while the cart
     qualifies). */
  (function () {
    /* gwp-debug logging: trace every gift-line mutation so cart-vs-checkout
       quantity changes can be attributed. */
    function gwpLog() {
      var args = ['[gwp-debug ' + new Date().toISOString() + ']'];
      for (var i = 0; i < arguments.length; i += 1) args.push(arguments[i]);
      console.log.apply(console, args);
    }

    function runGwpGuard() {
      var gwpGuards = Array.prototype.slice.call(document.querySelectorAll('[data-gwp-guard]'));
      var bxgyGuards = Array.prototype.slice.call(document.querySelectorAll('[data-bxgy-guard]'));
      if (gwpGuards.length === 0 && bxgyGuards.length === 0) return;

      /* Run once per page load - flag the first guard (alpine:init and
         DOMContentLoaded both call this). */
      var flagEl = gwpGuards[0] || bxgyGuards[0];
      if (flagEl.dataset.gwpGuardRan) return;
      flagEl.dataset.gwpGuardRan = 'true';

      /* Every live GWP offer's gid. A stamped gift line whose source is one
         of these (or a live BXGY source) is valid; anything else is orphaned.
         A bare cleanup guard (no live GWP offer) has an empty gid. */
      var gwpGids = {};
      gwpGuards.forEach(function (g) {
        if (g.dataset.discountGid) gwpGids[g.dataset.discountGid] = true;
      });

      gwpLog('guard start', {
        gwpGuards: gwpGuards.map(function (g) {
          return {
            gid: g.dataset.discountGid || '',
            eligible: g.dataset.eligible === 'true',
            allowance: g.dataset.allowance,
            autoVariant: g.dataset.autoVariant || '',
            allowedVariants: g.dataset.allowedVariants || '',
            activeTier: g.dataset.activeTier || '',
          };
        }),
        bxgyGuards: bxgyGuards.map(function (bx) {
          return { source: bx.dataset.source, entitled: bx.dataset.entitled, variant: bx.dataset.variant };
        }),
      });

      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart read failed (' + res.status + ')');
          return res.json();
        })
        .then(function (cart) {
          gwpLog('guard cart snapshot', JSON.stringify((cart.items || []).map(function (item) {
            return {
              key: item.key,
              variant_id: item.variant_id,
              quantity: item.quantity,
              title: item.title,
              final_line_price: item.final_line_price,
              properties: item.properties,
              discounts: item.line_level_discount_allocations,
            };
          })));
          var allGiftLines = (cart.items || []).filter(function (item) {
            return item.properties && item.properties._free_gift;
          });
          var gwpAutoNeeded = gwpGuards.some(function (g) {
            return g.dataset.eligible === 'true' && (g.dataset.autoVariant || '');
          });
          var bxgyNeedsWork = bxgyGuards.some(function (bx) {
            return (parseInt(bx.dataset.entitled, 10) || 0) > 0;
          });

          /* A cleanup guard renders even with NO live offer, so orphan
             cleanup below still runs after an offer ends, pauses, or expires. */

          /* Nothing to remove/trim AND nothing to auto-add: done. */
          if (allGiftLines.length === 0 && !gwpAutoNeeded && !bxgyNeedsWork) return null;

          var changes = [];
          var additions = [];

          /* GWP reconciliation - one pass per live GWP guard. Each guard
             manages only its offer's gift lines (matched by
             _free_gift_source == its gid); unstamped lines that carry no
             source are claimed by the first guard only, so two guards never
             both process the same line. Lines are partitioned by source, so
             the per-guard passes never collide. `guard`, `eligible`,
             `allowance`, `autoVariant`, `gwpGid` and `giftLines` below are
             this guard's locals. */
          gwpGuards.forEach(function (guard, guardIndex) {
            var eligible = guard.dataset.eligible === 'true';
            var allowance = parseInt(guard.dataset.allowance, 10) || 0;
            var autoVariant = guard.dataset.autoVariant || '';
            var gwpGid = guard.dataset.discountGid || '';
            var claimsUnstamped = guardIndex === 0;
            var giftLines = allGiftLines.filter(function (line) {
              var source = line.properties._free_gift_source;
              if (source) return source === gwpGid;
              return claimsUnstamped;
            });
          if (!eligible) {
            giftLines.forEach(function (line) {
              changes.push({ id: line.key, quantity: 0 });
            });
          } else if (autoVariant) {
            /* Single-option active tier (upgrade model): exactly one gift
               line - the auto variant at the full allowance. Everything
               else (previous tiers' gifts, stale selections) is swapped
               out. Add is best-effort: if the gift is unavailable the
               catch below no-ops and pricing stays correct server-side. */
            var autoLine = null;
            giftLines.forEach(function (line) {
              if (!autoLine && String(line.variant_id) === autoVariant) {
                autoLine = line;
                return;
              }
              changes.push({ id: line.key, quantity: 0 });
            });
            if (autoLine) {
              if (autoLine.quantity !== allowance) {
                changes.push({ id: autoLine.key, quantity: allowance });
              }
            } else {
              var giftProperties = { _free_gift: 'true' };
              if (guard.dataset.discountType) {
                giftProperties._free_gift_type = guard.dataset.discountType;
              }
              if (guard.dataset.discountGid) {
                giftProperties._free_gift_source = guard.dataset.discountGid;
              }
              if (guard.dataset.activeTier) {
                giftProperties._free_gift_tier = guard.dataset.activeTier;
              }
              additions.push({ id: Number(autoVariant), quantity: allowance, properties: giftProperties });
            }
          } else {
            /* Multi-option tier: [data-allowed-variants] is the ACTIVE
               tier's variant ids - drop gift lines outside it (the swap
               on tier change), then trim what's left to the allowance.
               Simple offers have no allowed list and just trim. */
            var allowed = {};
            var allowedRaw = (guard.dataset.allowedVariants || '').split(',').filter(Boolean);
            allowedRaw.forEach(function (id) {
              allowed[id] = true;
            });
            var hasAllowed = allowedRaw.length > 0;
            var remaining = allowance;
            giftLines.forEach(function (line) {
              if (hasAllowed && !allowed[String(line.variant_id)]) {
                changes.push({ id: line.key, quantity: 0 });
                return;
              }
              var keep = Math.min(line.quantity, Math.max(remaining, 0));
              remaining -= keep;
              if (keep !== line.quantity) {
                changes.push({ id: line.key, quantity: keep });
              }
            });
          }
          });

          /* BXGY reconciliation: one guard per live offer, its gift
             lines matched by _free_gift_source.
             Single-variant Y ([data-variant] set): the line is held at
             exactly the earned quantity - added when the X threshold is
             met, adjusted as X units change, removed at zero.
             Multi-option Y: the customer's chosen lines are trimmed to
             the entitlement (and removed when it drops to zero); adding
             is the selector's job. */
          var bxgySources = {};
          bxgyGuards.forEach(function (bx) {
            bxgySources[bx.dataset.source] = true;
          });
          bxgyGuards.forEach(function (bx) {
            var source = bx.dataset.source || '';
            var entitled = parseInt(bx.dataset.entitled, 10) || 0;
            var variantId = bx.dataset.variant || '';
            var mine = allGiftLines.filter(function (line) {
              return line.properties._free_gift_source === source;
            });

            if (entitled <= 0) {
              mine.forEach(function (line) {
                changes.push({ id: line.key, quantity: 0 });
              });
              return;
            }

            if (variantId) {
              var primary = null;
              mine.forEach(function (line) {
                if (!primary && String(line.variant_id) === variantId) {
                  primary = line;
                  return;
                }
                changes.push({ id: line.key, quantity: 0 });
              });
              if (primary) {
                if (primary.quantity !== entitled) {
                  changes.push({ id: primary.key, quantity: entitled });
                }
              } else {
                additions.push({
                  id: Number(variantId),
                  quantity: entitled,
                  properties: {
                    _free_gift: 'true',
                    _free_gift_type: 'buy_x_get_y',
                    _free_gift_source: source,
                  },
                });
              }
              return;
            }

            var bxRemaining = entitled;
            mine.forEach(function (line) {
              var keep = Math.min(line.quantity, Math.max(bxRemaining, 0));
              bxRemaining -= keep;
              if (keep !== line.quantity) {
                changes.push({ id: line.key, quantity: keep });
              }
            });
          });

          /* Orphaned gift lines: ANY stamped line (`_free_gift_source`)
             whose source is neither the live GWP guard's gid nor a live
             BXGY guard's - the offer ended, paused, expired, or was
             reconfigured - is removed regardless of `_free_gift_type`,
             so a dead offer's "free" line can't sit in the cart at $0.00
             display while checkout charges full price. Unstamped lines
             that carry no source belong to the GWP branch above. */
          allGiftLines.forEach(function (line) {
            var source = line.properties._free_gift_source;
            if (!source) return;
            if (gwpGids[source]) return;
            if (bxgySources[source]) return;
            changes.push({ id: line.key, quantity: 0 });
          });

          if (changes.length === 0 && additions.length === 0) {
            gwpLog('guard no-op (cart conforms)');
            return null;
          }

          gwpLog('guard WILL MUTATE', { changes: changes, additions: additions });

          /* Sequential - Shopify's cart endpoints reject concurrent
             mutations on the same cart. */
          var queue = Promise.resolve();
          changes.forEach(function (change) {
            queue = queue.then(function () {
              gwpLog('guard change.js ->', change);
              return fetch('/cart/change.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(change),
              }).then(function (res) {
                if (!res.ok) throw new Error('Cart change failed (' + res.status + ')');
                return res.json();
              });
            });
          });
          if (additions.length) {
            queue = queue.then(function () {
              gwpLog('guard add.js ->', additions);
              return fetch('/cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: additions }),
              }).then(function (res) {
                if (!res.ok) throw new Error('Cart add failed (' + res.status + ')');
                return res.json();
              });
            });
          }
          return queue.then(function () {
            gwpLog('guard mutations done -> reloading page');
            window.location.reload();
          });
        })
        .catch(function (error) {
          /* Best-effort guard - see comment above. */
          gwpLog('guard ERROR (no-op)', error && error.message);
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runGwpGuard);
    } else {
      runGwpGuard();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["horizontal-scroller"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('horizontalScroller', () => ({
      atStart: true,
      atEnd: false,
      scrollable: false,
      _rafId: null,
      init() {
        this.measure();
        this._onResize = () => this.schedule();
        window.addEventListener('resize', this._onResize, { passive: true });
      },
      destroy() {
        window.removeEventListener('resize', this._onResize);
      },
      measure() {
        const t = this.$refs.track;
        this.scrollable = t.scrollWidth > t.clientWidth + 1;
        this.atStart = t.scrollLeft <= 1;
        this.atEnd = t.scrollLeft + t.clientWidth >= t.scrollWidth - 1;
      },
      schedule() {
        if (this._rafId) return;
        this._rafId = requestAnimationFrame(() => {
          this._rafId = null;
          this.measure();
        });
      },
      step(direction) {
        const t = this.$refs.track;
        t.scrollBy({ left: direction * t.clientWidth * 0.85, behavior: 'smooth' });
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hotspot"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('hotspot', () => ({
      open: false,
      toggle() {
        if (!this.open) window.dispatchEvent(new CustomEvent('hotspot:close-others', { detail: { source: this.$root } }));
        this.open = !this.open;
      },
      close() {
        this.open = false;
      },
      closeIfOther(source) {
        if (source !== this.$root) this.open = false;
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-date"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Trailing calendar button opens the native date picker. */
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-input-date-trigger]');
      if (!trigger) return;
      const wrapper = trigger.closest('.input-date');
      if (!wrapper || wrapper.hasAttribute('data-disabled')) return;
      const control = wrapper.querySelector('.input-date__control');
      if (!control || control.disabled) return;
      if (typeof control.showPicker === 'function') {
        try {
          control.showPicker();
          return;
        } catch (e) {
          /* fall through to focus */
        }
      }
      control.focus();
    });

    /* Mirror the calendar button's disabled state onto the date control's,
       which consumers toggle directly. */
    const syncTrigger = (wrapper) => {
      const control = wrapper.querySelector('.input-date__control');
      const trigger = wrapper.querySelector('[data-input-date-trigger]');
      if (control && trigger) trigger.disabled = control.disabled;
    };
    const wire = (wrapper) => {
      const control = wrapper.querySelector('.input-date__control');
      if (!control) return;
      new MutationObserver(() => syncTrigger(wrapper)).observe(control, {
        attributes: true,
        attributeFilter: ['disabled'],
      });
      syncTrigger(wrapper);
    };
    const init = () => document.querySelectorAll('.input-date').forEach(wire);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    /* The initial value comes from Liquid rather than the rendered input so
       x-model can't blank a server-prefilled term on first bind. */
    Alpine.data('inputSearch', (initialValue = '') => ({
      value: initialValue,
      get hasValue() {
        return this.value !== '';
      },
      clear() {
        this.value = '';
        this.$refs.control.focus();
        this.$nextTick(() => {
          this.$refs.control.dispatchEvent(new Event('input', { bubbles: true }));
        });
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["instant-search-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    const DEBOUNCE_MS = 200;

    function updateInset() {
      const header = document.querySelector('.shopify-section--header');
      if (!header) return;
      /* On desktop, when the drawer is open we want the panel + scrim to
         sit flush below the main row (brand + search + right-nav) and
         visually overlay the nav row (mega-menu triggers). */
      const rootEl = document.querySelector('.header');
      const searchOpen = rootEl && rootEl.classList.contains('header--search-open');
      const isDesktop = window.matchMedia('(min-width: 1025px)').matches;
      let anchor = header;
      if (searchOpen && isDesktop) {
        const mainRow = document.querySelector('.header__desktop .header__row--main');
        if (mainRow && mainRow.offsetWidth > 0) anchor = mainRow;
      }
      const rect = anchor.getBoundingClientRect();
      document.documentElement.style.setProperty('--instant-search-inset', `${Math.max(0, rect.bottom)}px`);
    }

    /* Track the *visual* viewport height so the panel cap follows the on-screen
       keyboard. `dvh` ignores the keyboard, so with it up the panel stayed
       full-height and its content couldn't overflow/scroll above the keyboard. */
    function updateViewportHeight() {
      const vv = window.visualViewport;
      const h = vv ? vv.height : window.innerHeight;
      document.documentElement.style.setProperty('--instant-search-vh', `${Math.round(h)}px`);
    }

    /* Mirror the layout-level search-drawer-empty-group content into the
       drawer's empty-state slot. The Shopify `sections` tag is layout-only,
       so the group is rendered as a sibling of header-group at layout level.
       Clone (not move) so the source stays in place — Shopify's theme
       editor updates the section group via Section Rendering API. */
    (function portalEmptyGroup() {
      const source = document.querySelector('[data-instant-search-empty-source]');
      const target = document.querySelector('[data-instant-search-empty-target]');
      if (!source || !target) return;

      const sync = () => {
        /* Each direct child of `source` is a `shopify-section` wrapper
           emitted by the parent section-group render. Clone the WRAPPER'S
           CHILDREN (the section's actual rendered markup), skipping the
           shopify-section wrapper itself, so the editor's section-rendering
           target stays unique in the DOM and the editor does not see a
           duplicated section wrapper. */
        const clones = [];
        Array.from(source.children).forEach((shopifySection) => {
          Array.from(shopifySection.children).forEach((node) => {
            const clone = node.cloneNode(true);
            if (clone.id) clone.removeAttribute('id');
            clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
            clones.push(clone);
          });
        });
        target.replaceChildren(...clones);
        if (window.Alpine && typeof window.Alpine.initTree === 'function') {
          window.Alpine.initTree(target);
        }
      };

      sync();
      new MutationObserver(sync).observe(source, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      });
    })();

    Alpine.store('instantSearch', {
      open: false,
      query: '',
      state: 'closed',
      _lastNonLoadingState: 'default',
      results: { products: [], articles: [], collections: [], productsHtml: '', total: 0 },
      _timer: null,
      _abort: null,
      _trigger: null,
      _closing: false,
      _scrollBound: false,
      _needsFetch: false,

      /* Sidebar (suggested / categories / inspiration) visibility. */
      get sidebarVisible() {
        const state = this.state;
        const last = this._lastNonLoadingState;
        if (state === 'default' || state === 'empty') return true;
        if (state === 'loading' && (last === 'default' || last === 'empty')) return true;
        const withQuery = state === 'with-query' || (state === 'loading' && last === 'with-query');
        return withQuery && (this.results.collections.length > 0 || this.results.articles.length > 0);
      },

      openWith(trigger) {
        if (this.open) {
          this._refreshState();
          return;
        }
        /* Ignore focus echoes from close()'s focus-return: re-focusing the
           header input fires focusin on the header form, which must not
           re-open the drawer that close() just dismissed. */
        if (this._closing) return;
        this.open = true;
        /* Remember which header input opened the drawer so close() can
           return focus to the same one (desktop vs mobile). */
        this._trigger = trigger === 'mobile' ? 'mobile' : 'desktop';
        /* Pin the header where it currently sits before the scroll-lock. */
        const headerEl = document.querySelector('.shopify-section--header');
        if (headerEl) {
          const pinTop = Math.max(0, Math.round(headerEl.getBoundingClientRect().top));
          document.documentElement.style.setProperty('--instant-search-header-top', `${pinTop}px`);
        }
        document.documentElement.setAttribute('data-instant-search-open', '');
        /* Recompute the inset synchronously now the header is pinned (fixed)
           so the drawer anchors under it on the first frame, then again on
           rAF once layout has fully settled. */
        updateInset();
        this._refreshState();
        requestAnimationFrame(updateInset);
        updateViewportHeight();
        if (!this._scrollBound) {
          window.addEventListener('scroll', updateInset, { passive: true });
          window.addEventListener('resize', updateInset, { passive: true });
          if (window.visualViewport) {
            /* Keyboard show/hide + viewport pan fire on visualViewport, not
               window — re-cap the panel so it always fits above the keyboard. */
            window.visualViewport.addEventListener('resize', updateViewportHeight, { passive: true });
            window.visualViewport.addEventListener('scroll', updateViewportHeight, { passive: true });
          }
          this._scrollBound = true;
        }
      },

      close() {
        if (!this.open) return;
        /* Suppress focusin-triggered re-opens while the focus-return below
           re-focuses the header input (see openWith). */
        this._closing = true;
        this.open = false;
        document.documentElement.removeAttribute('data-instant-search-open');
        if (this._timer) { clearTimeout(this._timer); this._timer = null; }
        if (this._abort) { this._abort.abort(); this._abort = null; }
        /* Recompute inset once the class binding flips back so the
           variable reflects the full header height again (useful for
           any sticky content elsewhere that reads it). */
        requestAnimationFrame(updateInset);
        /* Return focus to whichever header search input triggered the
           drawer (desktop or mobile). Defensive checks only — if no
           input is found this is a no-op. */
        requestAnimationFrame(() => {
          const id = this._trigger === 'mobile' ? 'header-search-input-mobile' : 'header-search-input';
          const input = document.getElementById(id);
          if (input && typeof input.focus === 'function') input.focus();
          this._closing = false;
        });
      },

      /* Adopts a server-rendered term (the search results page prefills the
         header input) without firing a request: the drawer is closed at load
         time, so the fetch is deferred until it first opens. */
      seedQuery(value) {
        const next = (value || '').trim();
        if (!next || this.query) return;
        this.query = next;
        this._needsFetch = true;
      },

      setQuery(value) {
        const next = (value || '').trim();
        this.query = next;
        this._needsFetch = false;
        if (this._timer) clearTimeout(this._timer);
        if (!next) {
          if (this._abort) { this._abort.abort(); this._abort = null; }
          this.state = 'default';
          this._lastNonLoadingState = 'default';
          this.results = { products: [], articles: [], collections: [], productsHtml: '', total: 0 };
          return;
        }
        this._timer = setTimeout(() => this._fetch(), DEBOUNCE_MS);
      },

      _refreshState() {
        /* A seeded term has no results yet -- fetch them on first open. */
        if (this._needsFetch) {
          this._needsFetch = false;
          if (this.query) {
            this._fetch();
            return;
          }
        }
        if (!this.query) {
          this.state = 'default';
        } else if (this.results.total > 0) {
          this.state = 'with-query';
        } else if (this.state !== 'loading') {
          this.state = this.query ? 'empty' : 'default';
        }
        if (this.state !== 'loading') this._lastNonLoadingState = this.state;
      },

      async _fetch() {
        if (this._abort) this._abort.abort();
        this._abort = new AbortController();
        this.state = 'loading';
        try {
          /* Predictive search only searches title, product_type,
             variants.title, and vendor by default — SKU and barcode are
             supported fields but must be requested explicitly, otherwise a
             SKU query that resolves on the full /search page yields 0 hits
             here. Keep the default four and add the variant identifiers. */
          const searchFields = 'title,product_type,variants.title,vendor,variants.sku,variants.barcode';

          const jsonUrl = new URL('/search/suggest.json', window.location.origin);
          jsonUrl.searchParams.set('q', this.query);
          jsonUrl.searchParams.set('resources[type]', 'product,article,collection');
          jsonUrl.searchParams.set('resources[limit]', '8');
          jsonUrl.searchParams.set('resources[options][unavailable_products]', 'last');
          jsonUrl.searchParams.set('resources[options][fields]', searchFields);

          /* Parallel HTML fetch via the Section Rendering API so product hits
             render through the full `product-card` snippet (Articles and
             collections stay JSON-driven for inline text). */
          const htmlUrl = new URL('/search/suggest', window.location.origin);
          htmlUrl.searchParams.set('q', this.query);
          htmlUrl.searchParams.set('section_id', 'predictive-search-products');
          htmlUrl.searchParams.set('resources[type]', 'product');
          htmlUrl.searchParams.set('resources[limit]', '5');
          htmlUrl.searchParams.set('resources[options][unavailable_products]', 'last');
          htmlUrl.searchParams.set('resources[options][fields]', searchFields);

          /* Full-search grand total for the "View all" link. Predictive has
             no total, so hit the full /search engine via a count-only section
             so the number matches the destination page. */
          const countUrl = new URL('/search', window.location.origin);
          countUrl.searchParams.set('q', this.query);
          countUrl.searchParams.set('section_id', 'search-count');

          const fetchOpts = {
            credentials: 'same-origin',
            signal: this._abort.signal,
          };
          const [jsonResponse, htmlResponse] = await Promise.all([
            fetch(jsonUrl.toString(), { ...fetchOpts, headers: { Accept: 'application/json' } }),
            fetch(htmlUrl.toString(), { ...fetchOpts, headers: { Accept: 'text/html' } }),
          ]);
          if (!jsonResponse.ok) throw new Error('predictive search request failed');

          const json = await jsonResponse.json();
          const r = (json && json.resources && json.resources.results) || {};
          const decorate = (item) => ({ ...item, title_html: this._highlight(item.title) });
          /* Cap products at 4 to mirror the HTML fetch above so the rendered
             grid matches. Articles and collections stay at the JSON fetch's
             natural limit (8). */
          const products = (Array.isArray(r.products) ? r.products : []).slice(0, 4).map(decorate);
          const articles = (Array.isArray(r.articles) ? r.articles : []).map(decorate);
          const collections = (Array.isArray(r.collections) ? r.collections : []).map(decorate);

          let productsHtml = '';
          if (htmlResponse.ok) {
            productsHtml = this._extractProductsHtml(await htmlResponse.text());
          }

          /* Render the predictive results now; seed "View all" with the shown
             count and upgrade it to the true grand total when the non-blocking
             count request lands (below), so a slow count never delays results. */
          const shownTotal = products.length + articles.length + collections.length;
          this.results = { products, articles, collections, productsHtml, total: shownTotal };
          this.state = shownTotal > 0 ? 'with-query' : 'empty';
          this._lastNonLoadingState = this.state;

          this._loadGrandTotal(countUrl.toString(), this.query, this._abort.signal);
        } catch (err) {
          if (err && err.name === 'AbortError') return;
          this.state = this.query ? 'empty' : 'default';
        }
      },

      /* Extracts the [data-instant-search-products] wrapper contents from a
         search.predictive.liquid response. Falls back to the full body if the
         wrapper isn't found (defensive). */
      _extractProductsHtml(htmlText) {
        try {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlText, 'text/html');
          const wrapper = doc.querySelector('[data-instant-search-products]');
          return wrapper ? wrapper.innerHTML : '';
        } catch (e) {
          return '';
        }
      },

      /* Non-blocking: fetch the full-search grand total and fold it into the
         "View all" link once it lands, ignoring the response if the query has
         moved on (or the request was aborted by a newer keystroke). */
      _loadGrandTotal(url, forQuery, signal) {
        fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' }, signal })
          .then((res) => (res.ok ? res.text() : null))
          .then((text) => {
            if (text == null || this.query !== forQuery) return;
            const total = this._extractSearchTotal(text);
            if (total != null) this.results = { ...this.results, total };
          })
          .catch(() => {});
      },

      /* Reads the full-search grand total from the search-count section's
         `data-search-total` attribute; null if unparseable. */
      _extractSearchTotal(htmlText) {
        try {
          const doc = new DOMParser().parseFromString(htmlText, 'text/html');
          const el = doc.querySelector('[data-search-total]');
          if (!el) return null;
          const n = parseInt(el.getAttribute('data-search-total'), 10);
          return Number.isFinite(n) ? n : null;
        } catch (e) {
          return null;
        }
      },

      /* Tapping the close X next to the header search input: reset every
         header-mounted search input to empty (so re-opening the drawer
         starts fresh) and close the drawer. */
      clearAndClose() {
        document.querySelectorAll('.header__search input[type="search"]').forEach((input) => {
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
        this.close();
      },

      submitSearch() {
        const term = (this.query || '').trim();
        if (!term) {
          this.close();
          return;
        }
        const url = new URL('/search', window.location.origin);
        url.searchParams.set('q', term);
        window.location.href = url.toString();
      },

      /* Wraps each occurrence of the current query inside a string in <b> for
         accent-coloured highlighting. Escapes the input first so any HTML in
         titles is rendered as text, not interpreted. */
      _highlight(text) {
        const raw = String(text || '');
        const escaped = raw
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
        const term = (this.query || '').trim();
        if (!term) return escaped;
        const safeTerm = term
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
          .replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return escaped.replace(new RegExp(`(${safeTerm})`, 'gi'), '<b>$1</b>');
      },

      productImage(product) {
        if (!product) return null;
        const fi = product.featured_image;
        if (fi) {
          if (typeof fi === 'string') return fi;
          if (fi.url) return fi.url;
        }
        const i = product.image;
        if (i) {
          if (typeof i === 'string') return i;
          if (i.url) return i.url;
        }
        return null;
      },
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["members-price"] && !Shopify.designMode) return;
  try {
    /* WCAG 1.4.13: the hover/focus tooltip must be dismissible without
     moving the pointer. Escape hides every open members tooltip via a
     dismissed class; pointer-out / focus-out of the trigger re-arms it
     so the tooltip can be re-invoked. Document-level listeners because
     this snippet renders many times per page. */
  (function () {
    function rearm(event) {
      if (!event.target || !event.target.closest) return;
      var info = event.target.closest('.members-price__info');
      if (info && !info.contains(event.relatedTarget)) {
        info.classList.remove('members-price__info--dismissed');
      }
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.members-price__info').forEach(function (el) {
        el.classList.add('members-price__info--dismissed');
      });
    });
    document.addEventListener('mouseout', rearm);
    document.addEventListener('focusout', rearm);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nav-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.store('mobileNav', {
      activePanelId: 'root',
      panels: {},
      discover(root) {
        const map = {};
        root.querySelectorAll('[data-panel-id]').forEach((p, idx) => {
          map[p.dataset.panelId] = {
            title: p.dataset.panelTitle || '',
            url: p.dataset.panelUrl || '',
            index: idx,
            element: p,
          };
        });
        this.panels = map;
      },
      setActive(panelId) {
        if (!this.panels[panelId]) return;
        this.activePanelId = panelId;
      },
      reset() {
        this.activePanelId = 'root';
      },
      get isRoot() {
        return this.activePanelId === 'root';
      },
      get panelIndex() {
        return this.panels[this.activePanelId]?.index ?? 0;
      },
      get activeUrl() {
        const u = this.panels[this.activePanelId]?.url || '';
        return u && u !== '#' ? u : '';
      },
      get viewAllLabel() {
        const title = this.panels[this.activePanelId]?.title || '';
        return title ? `View All ${title}` : 'View All';
      },
    });

    Alpine.data('navDrawer', () => ({
      init() {
        Alpine.store('mobileNav').discover(this.$root);
        this.$watch('state.activePanelId', () => {
          this.$nextTick(() => {
            const active = Alpine.store('mobileNav').panels[Alpine.store('mobileNav').activePanelId];
            if (active?.element) active.element.scrollTop = 0;
          });
        });
      },
      get state() {
        return this.$store.mobileNav;
      },
      onDrawerOpen(event) {
        const dialog = event.target;
        if (!dialog?.contains?.(this.$root)) return;
        this.state.reset();
        /* Initial focus is handled natively: the .nav-drawer wrapper carries
           `tabindex="-1" autofocus`, so <dialog>.showModal() focuses that
           non-interactive container instead of the first focusable descendant. */
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["notification-banner"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('notificationBanner', () => ({
      dismiss() {
        this.$dispatch('notification-banner:dismiss');
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oci-cart-pushback"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('ociPushback', () => ({
      submitting: false,
      error: '',
      _serverCount: 0,

      init() {
        this._serverCount = Number(this.$root.dataset.initialCount) || 0;
      },

      get cartCount() {
        const store = this.$store.cart;
        if (store && store.item_count > 0) return store.item_count;
        return this._serverCount;
      },

      config() {
        const d = this.$root.dataset;
        return {
          market: d.market,
          unit: d.unit || 'EA',
          currency: d.currency || 'AUD',
          schema: d.schema || 'UNSPSC',
          vendor: d.vendor || '',
          priceUnit: d.priceUnit || '1',
          msgNoEndpoint: d.msgNoEndpoint || 'Missing return endpoint.',
          msgEmptyCart: d.msgEmptyCart || 'Your bag is empty.',
          msgCartRead: d.msgCartRead || "Couldn't read your bag.",
        };
      },

      session() {
        const key = 'oci_session_' + this.$root.dataset.market;
        const escaped = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        let raw = null;
        const match = document.cookie.match('(?:^|; )' + escaped + '=([^;]*)');
        if (match) raw = decodeURIComponent(match[1]);
        if (!raw) {
          try { raw = sessionStorage.getItem(key); } catch (e) { raw = null; }
        }
        if (!raw) return null;
        try { return JSON.parse(raw); } catch (e) { return null; }
      },

      async readCart() {
        const attempt = () =>
          fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then((res) => {
              if (!res.ok) throw new Error('cart read failed');
              return res.json();
            });
        try {
          return await attempt();
        } catch (first) {
          return await attempt();
        }
      },

      stripHtml(value) {
        const doc = new DOMParser().parseFromString(value || '', 'text/html');
        return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
      },

      buildForm(cart, cfg, session) {
        const form = document.createElement('form');
        form.method = 'post';
        form.action = session.HOOK_URL;
        form.target = session.TARGET || '_self';
        form.style.display = 'none';

        const add = (name, value) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value == null ? '' : String(value);
          form.appendChild(input);
        };

        if (session.OK_CODE) add('~OkCode', session.OK_CODE);
        if (session.OCI_VERSION) add('OCI_VERSION', session.OCI_VERSION);

        cart.items.forEach((item, idx) => {
          const n = idx + 1;
          const classification = (item.properties && item.properties._dec_classification) || '';
          add('NEW_ITEM-DESCRIPTION[' + n + ']', this.stripHtml(item.title).slice(0, 40));
          add('NEW_ITEM-QUANTITY[' + n + ']', item.quantity);
          add('NEW_ITEM-UNIT[' + n + ']', cfg.unit);
          add('NEW_ITEM-PRICE[' + n + ']', (item.final_price / 100).toFixed(2));
          add('NEW_ITEM-CURRENCY[' + n + ']', cart.currency || cfg.currency);
          add('NEW_ITEM-PRICEUNIT[' + n + ']', cfg.priceUnit);
          add('NEW_ITEM-VENDOR[' + n + ']', cfg.vendor);
          add('NEW_ITEM-EXT_CATEGORY_ID[' + n + ']', classification);
          add('NEW_ITEM-EXT_SCHEMA_TYPE[' + n + ']', cfg.schema);
          // Unimarket renders EXT_PRODUCT_ID as the line "Code"; Eckersley's needs
          // their per-variant SKU/EDP there so the item resolves uniquely.
          add('NEW_ITEM-EXT_PRODUCT_ID[' + n + ']', item.sku);
        });

        return form;
      },

      async pushBack() {
        if (this.submitting) return;
        this.error = '';
        const cfg = this.config();

        const session = this.session();
        if (!session || !session.HOOK_URL) {
          this.error = cfg.msgNoEndpoint;
          return;
        }

        this.submitting = true;
        let cart;
        try {
          cart = await this.readCart();
        } catch (e) {
          this.submitting = false;
          this.error = cfg.msgCartRead;
          return;
        }

        if (!cart || !cart.items || !cart.items.length) {
          this.submitting = false;
          this.error = cfg.msgEmptyCart;
          return;
        }

        const form = this.buildForm(cart, cfg, session);
        document.body.appendChild(form);

        try {
          await Alpine.store('cart').clear();
          this._serverCount = 0;
        } catch (e) {}

        form.submit();
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('productCardCarousel', () => ({
      atStart: true,
      atEnd: false,
      currentIndex: 0,
      total: 1,
      get fillWidth() {
        return 100 / this.total;
      },
      get fillOffset() {
        return this.currentIndex * 100;
      },
      init() {
        const track = this.$refs.track;
        if (!track) return;
        this.total = track.children.length || 1;
        this.update();
        this.$nextTick(() => this.update());
      },
      step(direction) {
        const track = this.$refs.track;
        if (!track) return;
        track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
      },
      onScroll() {
        this.update();
      },
      update() {
        const track = this.$refs.track;
        if (!track) return;
        const max = track.scrollWidth - track.clientWidth;
        this.atStart = track.scrollLeft <= 1;
        this.atEnd = track.scrollLeft >= max - 1;
        this.currentIndex = Math.min(this.total - 1, Math.round(track.scrollLeft / track.clientWidth));
      },
    }));
  });

  /* Deferred card projections. Cards rendered with
     data-card-projections="pending" skipped the discount-projection walk;
     fetch each product's own fully-walked card (its own Liquid budget) and
     transplant the badge stack and price block. Visible cards first via
     IntersectionObserver, at most CONCURRENCY in flight, re-scanned after
     plp.js swaps the grid (plp:updated). No Accept header: on a ?sections=
     request it makes Shopify return the page's own JSON instead. */
  (function () {
    var CONCURRENCY = 4;
    var SECTION = 'product-card-projections';
    var inFlight = 0;
    var queue = [];
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function endpoint(handle) {
      return root + 'products/' + encodeURIComponent(handle) + '?view=card-projections&sections=' + SECTION;
    }

    function transplant(card, html) {
      var template = document.createElement('template');
      template.innerHTML = html;
      var incoming = template.content.querySelector('[data-product-card]');
      if (!incoming) return false;
      ['[data-badge-stack]', '[data-card-price]'].forEach(function (selector) {
        var from = incoming.querySelector(selector);
        var to = card.querySelector(selector);
        if (from && to) to.innerHTML = from.innerHTML;
      });
      return true;
    }

    function load(card) {
      var handle = card.getAttribute('data-product-handle');
      if (!handle) {
        card.setAttribute('data-card-projections', 'failed');
        return;
      }
      card.setAttribute('data-card-projections', 'loading');
      inFlight += 1;
      fetch(endpoint(handle), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('card projections ' + response.status);
          return response.json();
        })
        .then(function (payload) {
          var ok = transplant(card, payload[SECTION] || '');
          card.setAttribute('data-card-projections', ok ? 'loaded' : 'failed');
        })
        .catch(function () {
          card.setAttribute('data-card-projections', 'failed');
        })
        .then(function () {
          inFlight -= 1;
          pump();
        });
    }

    function pump() {
      while (inFlight < CONCURRENCY && queue.length) {
        var card = queue.shift();
        if (card.getAttribute('data-card-projections') === 'pending') load(card);
      }
    }

    function enqueue(card, front) {
      if (queue.indexOf(card) !== -1) return;
      if (front) queue.unshift(card);
      else queue.push(card);
      pump();
    }

    var observer = 'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              enqueue(entry.target, true);
            });
          },
          { rootMargin: '300px 0px' }
        )
      : null;

    function scan() {
      document
        .querySelectorAll('[data-product-card][data-card-projections="pending"]')
        .forEach(function (card) {
          if (observer) observer.observe(card);
          enqueue(card, false);
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }
    document.addEventListener('plp:updated', scan);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-zoom"] && !Shopify.designMode) return;
  try {
    /* `Alpine.data('galleryZoom', ...)` — full-screen zoom dialog.
     Mounted on the `<dialog data-product-gallery-zoom>` via
     `x-data="galleryZoom"`. Thin Alpine shell around the existing
     pointer / wheel / pinch pan-and-zoom math — the algorithm is
     untouched; Alpine just owns the lifecycle and opens the dialog
     in response to the document-level `gallery:zoom-open` event
     that the productGallery component dispatches. */
  document.addEventListener('alpine:init', () => {
    function syncZoomThumbs(dialog, index) {
      const thumbs = dialog.querySelectorAll('[data-product-gallery-zoom-thumb]');
      thumbs.forEach((thumb, i) => {
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function attachZoomPan(pan) {
      let scale = 1;
      let originX = 0;
      let originY = 0;
      let dragging = false;
      let dragMovement = 0;
      let pointerDownX = 0;
      let pointerDownY = 0;
      let lastPointerX = 0;
      let lastPointerY = 0;
      const pointers = new Map();
      let pinchStartDistance = 0;
      let pinchStartScale = 1;
      /* Movement threshold below which a pointerup is treated as a tap
         and forwarded to the click handler (zoom toggle). Above the
         threshold the interaction is treated as a pan / pinch drag. */
      const DRAG_THRESHOLD_PX = 5;
      let wheelTimer = null;

      function apply() {
        pan.style.transform = `translate3d(${originX}px, ${originY}px, 0) scale(${scale})`;
        if (scale > 1.01) {
          pan.setAttribute('data-zoomed', '');
        } else {
          pan.removeAttribute('data-zoomed');
          originX = 0;
          originY = 0;
          pan.style.transform = '';
        }
      }

      function setScale(next, focalX, focalY) {
        const clamped = Math.max(1, Math.min(4, next));
        if (clamped === scale) return;
        const rect = pan.getBoundingClientRect();
        const cx = focalX != null ? focalX - rect.left - rect.width / 2 : 0;
        const cy = focalY != null ? focalY - rect.top - rect.height / 2 : 0;
        const ratio = clamped / scale;
        originX = cx - (cx - originX) * ratio;
        originY = cy - (cy - originY) * ratio;
        scale = clamped;
        apply();
      }

      function toggleZoomAt(clientX, clientY) {
        if (scale > 1) {
          scale = 1;
          originX = 0;
          originY = 0;
        } else {
          scale = 2;
          const rect = pan.getBoundingClientRect();
          originX = -(clientX - rect.left - rect.width / 2);
          originY = -(clientY - rect.top - rect.height / 2);
        }
        apply();
      }

      /* Click / tap to toggle zoom. On a zoomed image, real pan-drag
         moves the pointer above `DRAG_THRESHOLD_PX`, which suppresses
         the browser's native `click` — so this handler only fires for
         genuine taps. */
      pan.addEventListener('click', (event) => {
        toggleZoomAt(event.clientX, event.clientY);
      });

      pan.addEventListener(
        'wheel',
        (event) => {
          if (!event.ctrlKey && Math.abs(event.deltaY) < 30) return;
          event.preventDefault();
          pan.setAttribute('data-panning', '');
          const delta = -Math.sign(event.deltaY) * 0.2;
          setScale(scale + delta, event.clientX, event.clientY);
          clearTimeout(wheelTimer);
          wheelTimer = setTimeout(() => pan.removeAttribute('data-panning'), 120);
        },
        { passive: false }
      );

      pan.addEventListener('pointerdown', (event) => {
        pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        pointerDownX = event.clientX;
        pointerDownY = event.clientY;
        dragMovement = 0;
        if (pointers.size === 1) {
          if (scale > 1) {
            dragging = true;
            lastPointerX = event.clientX;
            lastPointerY = event.clientY;
            pan.setPointerCapture(event.pointerId);
          }
        } else if (pointers.size === 2) {
          const points = Array.from(pointers.values());
          const dx = points[0].x - points[1].x;
          const dy = points[0].y - points[1].y;
          pinchStartDistance = Math.hypot(dx, dy);
          pinchStartScale = scale;
          dragging = false;
          pan.setAttribute('data-panning', '');
        }
      });

      pan.addEventListener('pointermove', (event) => {
        if (!pointers.has(event.pointerId)) return;
        pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

        const totalMovement = Math.hypot(
          event.clientX - pointerDownX,
          event.clientY - pointerDownY
        );
        if (totalMovement > dragMovement) dragMovement = totalMovement;

        if (pointers.size === 2) {
          const points = Array.from(pointers.values());
          const dx = points[0].x - points[1].x;
          const dy = points[0].y - points[1].y;
          const distance = Math.hypot(dx, dy);
          const focalX = (points[0].x + points[1].x) / 2;
          const focalY = (points[0].y + points[1].y) / 2;
          if (pinchStartDistance > 0) {
            const nextScale = pinchStartScale * (distance / pinchStartDistance);
            setScale(nextScale, focalX, focalY);
          }
          event.preventDefault();
        } else if (dragging) {
          if (dragMovement > DRAG_THRESHOLD_PX) {
            pan.setAttribute('data-panning', '');
          }
          const dx = event.clientX - lastPointerX;
          const dy = event.clientY - lastPointerY;
          lastPointerX = event.clientX;
          lastPointerY = event.clientY;
          originX += dx;
          originY += dy;
          apply();
          event.preventDefault();
        }
      });

      function releasePointer(event) {
        pointers.delete(event.pointerId);
        if (pointers.size < 2) pinchStartDistance = 0;
        if (pointers.size === 0) {
          dragging = false;
          pan.removeAttribute('data-panning');
        }
      }

      pan.addEventListener('pointerup', releasePointer);
      pan.addEventListener('pointercancel', releasePointer);
      pan.addEventListener('pointerleave', releasePointer);
    }

    window.Alpine.data('galleryZoom', () => ({
      _track: null,
      _panels: [],

      init() {
        const dialog = this.$root;
        if (dialog.dataset.zoomReady === '1') return;
        dialog.dataset.zoomReady = '1';

        this._track = dialog.querySelector('[data-product-gallery-zoom-track]');
        this._panels = Array.from(
          dialog.querySelectorAll('[data-product-gallery-zoom-panel]')
        );
        const thumbs = Array.from(
          dialog.querySelectorAll('[data-product-gallery-zoom-thumb]')
        );
        const closeBtn = dialog.querySelector('[data-product-gallery-zoom-close]');
        const prevBtn = dialog.querySelector('[data-product-gallery-zoom-prev]');
        const nextBtn = dialog.querySelector('[data-product-gallery-zoom-next]');

        closeBtn && closeBtn.addEventListener('click', () => dialog.close());
        prevBtn &&
          prevBtn.addEventListener('click', () => this.goto(this.currentIndex() - 1));
        nextBtn &&
          nextBtn.addEventListener('click', () => this.goto(this.currentIndex() + 1));

        thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () =>
            this.goto(Number(thumb.dataset.index) || 0)
          );
        });

        this._track &&
          this._track.addEventListener('scroll', () =>
            syncZoomThumbs(dialog, this.currentIndex())
          );

        dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.goto(this.currentIndex() - 1);
          else if (event.key === 'ArrowRight') this.goto(this.currentIndex() + 1);
        });

        this._panels.forEach((panel) => {
          const pan = panel.querySelector('[data-product-gallery-zoom-pan]');
          if (!pan) return;
          attachZoomPan(pan);
        });

        document.addEventListener('gallery:zoom-open', (event) => {
          this.open(event.detail && event.detail.mediaId);
        });
      },

      currentIndex() {
        if (!this._track) return 0;
        const center = this._track.scrollLeft + this._track.clientWidth / 2;
        let closest = 0;
        let closestDistance = Infinity;
        this._panels.forEach((panel, i) => {
          const c = panel.offsetLeft + panel.clientWidth / 2;
          const d = Math.abs(c - center);
          if (d < closestDistance) {
            closestDistance = d;
            closest = i;
          }
        });
        return closest;
      },

      goto(index) {
        const clamped = Math.max(0, Math.min(this._panels.length - 1, index));
        const panel = this._panels[clamped];
        if (panel && this._track) {
          this._track.scrollTo({ left: panel.offsetLeft, behavior: 'smooth' });
          syncZoomThumbs(this.$root, clamped);
        }
      },

      open(mediaId) {
        const dialog = this.$root;
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        let index = 0;
        if (mediaId != null) {
          const targetMediaId = String(mediaId);
          const found = this._panels.findIndex((p) => p.dataset.mediaId === targetMediaId);
          if (found >= 0) index = found;
        }
        const target = this._panels[index];
        if (target) {
          target.scrollIntoView({ behavior: 'auto', inline: 'start', block: 'start' });
        }
        syncZoomThumbs(dialog, index);
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    /* `Alpine.data('productGallery', ...)` - mounts on the gallery wrapper
     via `x-data="productGallery"`. Wraps the imperative scroll + thumb
     sync + overflow + active-index math in a thin Alpine lifecycle.
     Reacts to `$store.pdp.variantId` to scroll the main track to the
     active variant's featured media (via the server-emitted
     `data-variant-media-map` variantId → mediaId map). Each image panel
     dispatches `gallery:zoom-open` for the zoom dialog (mounted on the
     sibling `<dialog>`) to consume at the document level. */
  document.addEventListener('alpine:init', () => {
    window.Alpine.data('productGallery', () => ({
      activeIndex: 0,
      _track: null,
      _thumbs: [],
      _panels: [],
      _prevBtn: null,
      _nextBtn: null,
      _thumbsCol: null,
      _thumbsList: null,
      _thumbsMore: null,
      _viewport: null,
      _scrollTimer: null,
      _resizeObserver: null,
      _variantMediaMap: null,

      init() {
        const gallery = this.$root;
        if (gallery.dataset.galleryReady === '1') return;
        gallery.dataset.galleryReady = '1';

        this._variantMediaMap = new Map();
        (gallery.dataset.variantMediaMap || '')
          .split(',')
          .filter(Boolean)
          .forEach((pair) => {
            const [vid, mid] = pair.split(':');
            if (vid && mid) this._variantMediaMap.set(String(vid), String(mid));
          });

        this._track = gallery.querySelector('[data-product-gallery-track]');
        this._thumbs = Array.from(gallery.querySelectorAll('[data-product-gallery-thumb]'));
        this._panels = Array.from(gallery.querySelectorAll('[data-product-gallery-panel]'));
        this._prevBtn = gallery.querySelector('[data-product-gallery-prev]');
        this._nextBtn = gallery.querySelector('[data-product-gallery-next]');
        this._thumbsCol = gallery.querySelector('[data-product-gallery-thumbs-col]');
        this._thumbsList = gallery.querySelector('[data-product-gallery-thumbs]');
        this._thumbsMore = gallery.querySelector('[data-product-gallery-thumbs-more]');
        this._viewport = gallery.querySelector('.product-gallery__viewport');

        if (this._viewport) {
          if ('ResizeObserver' in window) {
            this._resizeObserver = new ResizeObserver(() => this.syncThumbsHeight());
            this._resizeObserver.observe(this._viewport);
          } else {
            window.addEventListener('resize', () => this.syncThumbsHeight());
          }
          requestAnimationFrame(() => this.syncThumbsHeight());
        }

        if (this._thumbsList) {
          this._thumbsList.addEventListener('scroll', () => this.updateThumbsOverflow());
        }
        if (this._thumbsMore) {
          this._thumbsMore.addEventListener('click', () => {
            if (!this._thumbsList) return;
            this._thumbsList.scrollBy({
              top: this._thumbsList.clientHeight * 0.8,
              behavior: 'smooth',
            });
          });
        }

        if (this._prevBtn) {
          this._prevBtn.addEventListener('click', () =>
            this.scrollToPanel(Math.max(0, this.activeIndex - 1))
          );
        }
        if (this._nextBtn) {
          this._nextBtn.addEventListener('click', () =>
            this.scrollToPanel(Math.min(this._panels.length - 1, this.activeIndex + 1))
          );
        }
        this.setActiveIndex(0);

        this._thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const index = Number(thumb.dataset.index) || 0;
            this.scrollToPanel(index);
          });
        });

        this._panels.forEach((panel) => {
          if (panel.dataset.mediaType !== 'image') return;
          panel.addEventListener('click', () => {
            document.dispatchEvent(
              new CustomEvent('gallery:zoom-open', {
                detail: { mediaId: panel.dataset.mediaId },
              })
            );
          });
        });

        if (this._track) {
          this._track.addEventListener('scroll', () => this.onTrackScroll());
        }

        this.$watch('$store.pdp.variantId', () => {
          this.scrollToActiveVariantMedia();
        });

        /* Jump the main track to the active variant's media on load only. */
        if (gallery.dataset.galleryPreselect === 'true') {
          requestAnimationFrame(() => this.scrollToActiveVariantMedia(false));
        }
      },

      syncThumbsHeight() {
        if (!this._thumbsCol || !this._viewport) return;
        this._thumbsCol.style.setProperty(
          '--gallery-col-height',
          this._viewport.clientHeight + 'px'
        );
        this.updateThumbsOverflow();
      },

      updateThumbsOverflow() {
        if (!this._thumbsList || !this._thumbsMore) return;
        const overflowing =
          this._thumbsList.scrollHeight - this._thumbsList.clientHeight > 1;
        const atBottom =
          this._thumbsList.scrollTop + this._thumbsList.clientHeight >=
          this._thumbsList.scrollHeight - 1;
        this._thumbsMore.hidden = !overflowing || atBottom;
      },

      setActiveIndex(index) {
        this.activeIndex = index;
        this._thumbs.forEach((thumb, i) => {
          const isActive = i === index;
          thumb.classList.toggle('product-gallery__thumb-button--selected', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
        /* Hide the arrow at either end instead of rendering a disabled
           state - matches the product-card carousel UX. */
        if (this._prevBtn) {
          this._prevBtn.hidden = index <= 0;
          this._prevBtn.disabled = index <= 0;
        }
        if (this._nextBtn) {
          this._nextBtn.hidden = index >= this._panels.length - 1;
          this._nextBtn.disabled = index >= this._panels.length - 1;
        }
      },

      scrollToPanel(index, smooth = true) {
        const panel = this._panels[index];
        if (!panel || !this._track) return;
        this._track.scrollTo({
          left: panel.offsetLeft,
          behavior: smooth ? 'smooth' : 'auto',
        });
        this.setActiveIndex(index);
      },

      pauseAllVideos() {
        this._panels.forEach((panel) => {
          const video = panel.querySelector('video');
          if (video && !video.paused) video.pause();
        });
      },

      onTrackScroll() {
        if (this._scrollTimer) window.clearTimeout(this._scrollTimer);
        this._scrollTimer = window.setTimeout(() => {
          const center = this._track.scrollLeft + this._track.clientWidth / 2;
          let closestIndex = 0;
          let closestDistance = Infinity;
          this._panels.forEach((panel, i) => {
            const panelCenter = panel.offsetLeft + panel.clientWidth / 2;
            const distance = Math.abs(panelCenter - center);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = i;
            }
          });
          if (closestIndex !== this.activeIndex) this.pauseAllVideos();
          this.setActiveIndex(closestIndex);
        }, 80);
      },

      scrollToActiveVariantMedia(smooth = true) {
        const store = this.$store.pdp;
        if (!store || store.variantId == null) return;
        /* Server-emitted variantId → mediaId map — see the `data-variant-media-map`
           attribute on the gallery root. `variant.featured_image.id` from the
           JS payload is an image resource id, not a media id, so it can't be
           matched against `data-media-id` on the panels. */
        const targetId = this._variantMediaMap.get(String(store.variantId));
        if (!targetId) return;
        const index = this._panels.findIndex(
          (panel) => panel.dataset.mediaId === targetId
        );
        if (index >= 0) this.scrollToPanel(index, smooth);
      },

      destroy() {
        if (this._resizeObserver) this._resizeObserver.disconnect();
        if (this._scrollTimer) window.clearTimeout(this._scrollTimer);
      },
    }));
  });

  /* Percent-off badge, relabelled as the picker moves. Same precedence and
     the same integer floor as `sale-badge` and the other surfaces: the picked
     variant's own markdown first, then the members percentage when that
     variant is full price and inside the discount's variant gate; on
     deselection, back to the whole-product label. Document-level listener
     because `variant:change` bubbles from the picker and the PDP renders one
     gallery. */
  (function () {
    function relabelPercentOff(event) {
      var stack = document.querySelector('[data-badge-stack][data-percent-off-template]');
      if (!stack) return;
      var wrapper = stack.querySelector('[data-percent-off-badge]');
      if (!wrapper) return;
      var label = wrapper.querySelector('.badge__label');
      if (!label) return;

      var template = stack.dataset.percentOffTemplate || '';
      var membersPercentage = Number(stack.dataset.membersPercentage) || 0;
      var gateIds = (stack.dataset.membersGateVariantIds || '').split(',').filter(Boolean);
      var variant = (event.detail && event.detail.variant) || null;

      /* Deselection: the whole-product label, which already carries the
         members fallback from the server render. */
      if (!variant) {
        var productLabel = stack.dataset.percentOffProductLabel || '';
        if (productLabel) label.textContent = productLabel;
        wrapper.hidden = !productLabel;
        return;
      }

      var percentage = 0;
      var compare = Number(variant.compare_at_price);
      var price = Number(variant.price);
      if (Number.isFinite(compare) && compare > price) {
        percentage = Math.floor(((compare - price) * 100) / compare);
      }
      if (percentage <= 0 && membersPercentage > 0) {
        var inGate = gateIds.length === 0 || gateIds.indexOf(String(variant.id)) !== -1;
        if (inGate) percentage = membersPercentage;
      }

      if (percentage > 0) label.textContent = template.replace('__PERCENT__', percentage);
      wrapper.hidden = percentage <= 0;
    }

    document.addEventListener('variant:change', relabelPercentOff);
  })();

  /* Variant-level flag badges (Exclusive / Clearance / Online only), shown and
     hidden as the picker moves - the same variant-gated, reactive mechanism as
     the percent-off badge. Each flag carries its own list of variant ids; a
     badge shows only while the picked variant's id is in its list. On
     deselection every flag reverts to its server-rendered seed. */
  (function () {
    var FLAGS = [
      { key: 'exclusive', attr: 'flagExclusiveIds' },
      { key: 'clearance', attr: 'flagClearanceIds' },
      { key: 'online_only', attr: 'flagOnlineOnlyIds' },
    ];

    function relabelFlags(event) {
      var stack = document.querySelector('[data-badge-stack][data-flag-exclusive-ids], [data-badge-stack][data-flag-clearance-ids], [data-badge-stack][data-flag-online-only-ids]');
      if (!stack) return;
      var variant = (event.detail && event.detail.variant) || null;

      FLAGS.forEach(function (flag) {
        var badge = stack.querySelector('[data-flag-badge="' + flag.key + '"]');
        if (!badge) return;

        /* Deselection: restore the server-rendered seed carried on the
           wrapper's `data-flag-seed-hidden`. */
        if (!variant) {
          badge.hidden = badge.dataset.flagSeedHidden === 'true';
          return;
        }

        var ids = (stack.dataset[flag.attr] || '').split(',').filter(Boolean);
        badge.hidden = ids.indexOf(String(variant.id)) === -1;
      });
    }

    document.addEventListener('variant:change', relabelFlags);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('quantitySelector', () => ({
      value: 0,
      min: 1,
      max: Infinity,
      increment: 1,
      init() {
        const input = this.$refs.input;
        const parsedMin = Number(input.min);
        this.min = Number.isFinite(parsedMin) ? parsedMin : 1;
        this.max = input.max === '' ? Infinity : Number(input.max);
        this.increment = Number(input.step) || 1;
        const parsedValue = Number(input.value);
        const seedValue = Number.isFinite(parsedValue) ? parsedValue : this.min;
        this.value = this.clamp(seedValue);

        /* Cart lines opt in via `data-persist-clamp`: when the stored
           quantity sits above the current stock ceiling, the clamp above
           lowered the DISPLAYED value but the cart still holds the larger
           number, so the count on screen disagrees with what checkout
           charges. Emit once (after mount, so the owner's listener is
           attached) to persist the corrected value back to the cart.
           A downward correction only — an in-range value is a no-op. The
           correction can never drop below the MOQ floor: a line whose stock
           has fallen under its MOQ renders no `max` (unbounded), so `clamp`
           leaves the value untouched and this never fires. */
        if (this.$root.hasAttribute('data-persist-clamp') && this.value < seedValue) {
          this.$nextTick(() => this.emit());
        }

        /* External components push a tighter upper bound here when the
           selected variant changes -- e.g. the buy-buttons block sends
           the new variant's grid-snapped inventory ceiling so the `+`
           button disables at the right cap. An empty/undefined max
           resets to unbounded. The DOM `max` attribute is kept in sync
           so browser HTML5 validation stays aligned with the current
           variant (otherwise the initial-render max sticks and the
           browser shows misleading "Value must be N." bubbles after
           the variant changes). */
        this.$root.addEventListener('quantity:set-max', (event) => {
          const next = event.detail && event.detail.max;
          if (next === null || next === undefined || next === '') {
            this.max = Infinity;
            input.removeAttribute('max');
          } else {
            this.max = Number(next);
            input.max = String(next);
          }
          this.value = this.clamp(this.value);
          this.refreshValidity();
          this.emit();
        });

        /* Full MOQ rule push for surfaces whose min / step / max all vary
           per variant (variant-level `unifd.moq_*`). Any omitted key is
           left unchanged; an empty/undefined max resets to unbounded. The
           DOM min / step / max attrs are kept in sync so HTML validation
           and the native stepper track the active variant, then the value
           is re-snapped to the new grid.

           An optional `value` in the payload wins over that re-snap, for
           surfaces restoring a stored quantity rather than starting at the
           floor -- the requisition list reads `qty` back off the Swym list
           item this way. Omit it and the original behaviour stands. */
        this.$root.addEventListener('quantity:set-rule', (event) => {
          const detail = event.detail || {};
          const prevMin = this.min;
          const prevStep = this.increment;
          if (detail.min !== null && detail.min !== undefined && detail.min !== '') {
            this.min = Number(detail.min) || 1;
            input.min = String(this.min);
          }
          if (detail.step !== null && detail.step !== undefined && detail.step !== '') {
            this.increment = Number(detail.step) || 1;
            input.step = String(this.increment);
          }
          if (detail.max === null || detail.max === undefined || detail.max === '') {
            this.max = Infinity;
            input.removeAttribute('max');
          } else {
            this.max = Number(detail.max);
            input.max = String(detail.max);
          }
          /* When the variant's MOQ floor/step actually changes, re-initialise
             to the new minimum. */
          const ruleChanged = this.min !== prevMin || this.increment !== prevStep;
          const requested = detail.value;
          if (requested !== null && requested !== undefined && requested !== '') {
            this.value = this.clamp(Number(requested) || this.min);
          } else {
            this.value = ruleChanged ? this.min : this.clamp(this.value);
          }
          this.refreshValidity();
          this.emit();
        });
      },
      get atMin() {
        return this.value <= this.min;
      },
      get atMax() {
        return this.value >= this.max;
      },
      /* Snap to the step grid measured from `min`, then bound to [min, max]. */
      clamp(n) {
        const stepped = this.min + Math.round((n - this.min) / this.increment) * this.increment;
        return Math.max(this.min, Math.min(this.max, stepped));
      },
      step(delta) {
        this.value = this.clamp(this.value + delta * this.increment);
        this.refreshValidity();
        this.emit();
      },
      sync() {
        this.value = this.clamp(Number(this.value) || this.min);
        this.refreshValidity();
        this.emit();
      },
      /* Live handler: swaps the browser's misleading built-in error text
         ("Value must be N.") for an inventory-aware message before the
         input blurs. Without this, a shopper who types a valid MOQ
         multiple that exceeds available stock sees "Value must be 6."
         and reads it as a step/MOQ error, not an inventory cap. Called
         from `@input` so it beats the browser bubble on submit. */
      onInput() {
        this.refreshValidity();
      },
      refreshValidity() {
        const input = this.$refs.input;
        if (!input || typeof input.setCustomValidity !== 'function') return;
        const numeric = Number(this.value);
        if (Number.isFinite(numeric) && this.max !== Infinity && numeric > this.max) {
          input.setCustomValidity(`Only ${this.max} available.`);
        } else {
          input.setCustomValidity('');
        }
      },
      emit() {
        this.$dispatch('quantity:change', {
          value: this.value,
          name: this.$refs.input.name,
          key: this.$root.dataset.lineItemKey || null,
        });
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-drawer"] && !Shopify.designMode) return;
  try {
    /* `Alpine.data('quickAddForm', ...)` — self-contained drawer state.
     Mounts on the inner `[data-quick-add]` element when the section is
     injected into the drawer body. Does NOT use the page-wide
     `Alpine.store('pdp')` so multiple drawer-opens (each opening a
     different product) don't collide. Registered here in the global
     drawer snippet because the snippet is rendered on every page; the
     section file (where it would naturally live) only loads on PDPs. */
  document.addEventListener('alpine:init', function () {
    if (!window.Alpine) return;
    window.Alpine.data('quickAddForm', function () {
      return {
        productId: null,
        variantId: null,
        quantity: 1,
        moqMin: 1,
        moqStep: 1,
        moqMax: Infinity,
        oosIds: new Set(),
        channelHiddenIds: new Set(),
        belowMoqIds: new Set(),
        variantMaxMap: new Map(),
        variantMoqMap: new Map(),
        /* Uncapped colour-value -> variant map for single-option colour
           products (Daniel Smith 271, Copic 358). Keyed by the colour
           option value, each entry carries { id, oos, belowMoq, hazBlocked,
           min, step, max } sourced server-side from `value.variant`, so a
           colour past Shopify's 250-variant payload cap still resolves.
           Empty (size 0) on multi-option products, which keep the capped
           `productPayload` resolution path. */
        colourVariantMap: new Map(),
        /* The colour-map entry for the current pick, or null. Preferred over
           the capped id-sets (`oosIds` etc.) for the CTA + MOQ when present. */
        selectedColourEntry: null,
        hazardousBlockedIds: new Set(),
        hazardousIds: new Set(),
        bulkyIds: new Set(),
        ctaLabels: { default: '', soldOut: '', hazardousBlocked: '', selectTemplate: '' },
        productPayload: null,
        moneyFormat: (window.theme && window.theme.moneyFormat) || '',
        /* Drives the reactive price. Null until a complete pick — while
           null the getters fall back to the product range. */
        selectedVariant: null,
        /* Percent-off badge copy: whole-product "Up To X% Off" (shown until a
           variant is picked) + the localised "__PERCENT__% Off" pattern the
           getter fills per variant. */
        saleProductLabel: '',
        saleLabelTemplate: '',
        /* Members discount percentage and the variant ids it covers (empty =
           every variant), from the same projection surface as the server
           render so the badge cannot change figure between the two. */
        membersPercentage: 0,
        membersGateVariantIds: [],
        /* Variant ids carrying each flag badge (Exclusive / Clearance / Online
           only). A flag shows only while the active variant's id is listed;
           empty = no variant carries it. */
        flagExclusiveIds: [],
        flagClearanceIds: [],
        flagOnlineOnlyIds: [],
        /* At-rest seed baseline (nothing picked): Exclusive / Online only show
           only when EVERY variant carries the flag, Clearance when ANY does.
           Matches the SSR seed and the product-card / PDP at-rest state. */
        flagSeedExclusive: false,
        flagSeedClearance: false,
        flagSeedOnlineOnly: false,

        init: function () {
          var root = this.$root;
          this.productId = root.dataset.productId || null;
          this.variantId = Number(root.dataset.initialVariantId) || null;
          this.moqMin = Number(root.dataset.moqMin) || 1;
          this.moqStep = Number(root.dataset.moqStep) || 1;
          this.moqMax = root.dataset.moqMax ? Number(root.dataset.moqMax) : Infinity;
          this.quantity = this.moqMin;
          this.hazardousBlockedIds = new Set((root.dataset.hazardousBlockedIds || '').split(',').filter(Boolean));
          this.hazardousIds = new Set((root.dataset.hazardousIds || '').split(',').filter(Boolean));
          this.bulkyIds = new Set((root.dataset.bulkyIds || '').split(',').filter(Boolean));
          this.saleProductLabel = root.dataset.saleProductLabel || '';
          this.saleLabelTemplate = root.dataset.saleLabelTemplate || '';
          this.membersPercentage = Number(root.dataset.membersPercentage) || 0;
          this.membersGateVariantIds = (root.dataset.membersGateVariantIds || '')
            .split(',')
            .filter(Boolean);
          this.flagExclusiveIds = (root.dataset.flagExclusiveIds || '').split(',').filter(Boolean);
          this.flagClearanceIds = (root.dataset.flagClearanceIds || '').split(',').filter(Boolean);
          this.flagOnlineOnlyIds = (root.dataset.flagOnlineOnlyIds || '').split(',').filter(Boolean);
          this.flagSeedExclusive = root.dataset.flagSeedExclusive === 'true';
          this.flagSeedClearance = root.dataset.flagSeedClearance === 'true';
          this.flagSeedOnlineOnly = root.dataset.flagSeedOnlineOnly === 'true';

          this.oosIds = new Set(
            (root.dataset.oosIds || '').split(',').filter(Boolean)
          );
          /* Variants hidden from the Online Store channel. Used to filter
             the embedded payload below so no client resolution can reach
             them. Empty for an all-online product — fail-open. */
          this.channelHiddenIds = new Set(
            (root.dataset.channelHiddenIds || '').split(',').filter(Boolean)
          );
          this.belowMoqIds = new Set(
            (root.dataset.belowMoqIds || '').split(',').filter(Boolean)
          );
          this.variantMaxMap = new Map(
            (root.dataset.variantMaxMap || '')
              .split(',')
              .filter(Boolean)
              .map(function (entry) {
                var parts = entry.split(':');
                return [parts[0], Number(parts[1])];
              })
          );
          this.variantMoqMap = new Map(
            (root.dataset.variantMoqMap || '')
              .split(',')
              .filter(Boolean)
              .map(function (entry) {
                var parts = entry.split(':');
                return [parts[0], { min: Number(parts[1]) || 1, step: Number(parts[2]) || 1 }];
              })
          );

          var cta = root.querySelector('[data-quick-add-form]');
          if (cta) {
            this.ctaLabels = {
              default: cta.dataset.ctaLabelDefault || '',
              soldOut: cta.dataset.ctaLabelSoldOut || '',
              hazardousBlocked: cta.dataset.ctaLabelHazardousBlocked || '',
              selectTemplate: cta.dataset.ctaLabelSelectTemplate || '',
            };
          }

          var payloadEl = root.querySelector('[data-quick-add-payload]');
          if (payloadEl) {
            try {
              var parsedPayload = JSON.parse(payloadEl.textContent);
              /* Drop channel-hidden variants up front so every downstream
                 read (resolve, availability, price range) sees only the
                 visible set. Fail-open: an empty set returns the payload
                 unchanged. */
              var utils = window.theme && window.theme.variantUtils;
              this.productPayload =
                utils && typeof utils.filterHiddenVariants === 'function'
                  ? utils.filterHiddenVariants(parsedPayload, this.channelHiddenIds)
                  : parsedPayload;
            } catch (e) {
              this.productPayload = null;
            }
          }

          var self = this;

          /* Uncapped colour -> variant map (single-option colour products
             only; empty attribute on multi-option). Keyed by the colour
             value so a pick resolves its variant id + stock/MOQ even when
             the variant sits past the 250-cap on `productPayload`. */
          this.colourVariantMap = new Map();
          try {
            var rawColourMap = root.dataset.colourVariantMap || '';
            if (rawColourMap) {
              var parsedColourMap = JSON.parse(rawColourMap);
              if (Array.isArray(parsedColourMap)) {
                parsedColourMap.forEach(function (entry) {
                  if (!entry || entry.v == null) return;
                  self.colourVariantMap.set(String(entry.v), {
                    id: Number(entry.id),
                    oos: !!entry.oos,
                    belowMoq: !!entry.belowMoq,
                    hazBlocked: !!entry.hazBlocked,
                    min: Number(entry.min) || 1,
                    step: Number(entry.step) || 1,
                    max: entry.max == null ? Infinity : Number(entry.max),
                  });
                });
              }
            }
          } catch (e) {
            this.colourVariantMap = new Map();
          }

          root.querySelectorAll('[data-quick-add-option-input]').forEach(function (input) {
            input.addEventListener('change', function () { self.onOptionChange(); });
          });

          /* Re-clicking the selected pill deselects it (radios can't toggle
             off natively). Ignore the synthesized click a label fires on its
             own radio (target is the input) so a fresh pick isn't undone. */
          root.addEventListener('click', function (event) {
            if (event.target.matches('[data-quick-add-option-input]')) return;
            var pill = event.target.closest('.quick-add__pill');
            if (!pill) return;
            var input = pill.querySelector('[data-quick-add-option-input]');
            if (!input || input.disabled || !input.checked) return;
            event.preventDefault();
            input.checked = false;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });

          root.addEventListener('quantity:change', function (event) {
            var value = Number(event.detail && event.detail.value) || self.moqMin;
            self.quantity = value;
          });

          var form = root.querySelector('[data-quick-add-form]');
          if (form) {
            form.addEventListener('submit', function (event) { self.onSubmit(event, form); });
          }

          this.applyVariantMax();
          /* Prime the option availability matrix so any pre-selected
             value (e.g. one-option products) reflects real reachability
             from the initial pick, and unreachable siblings appear muted
             the moment the drawer opens rather than only after the first
             click. */
          this.refreshAvailability();
          this.updateRestrictionNotices();
        },

        formatMoney: function (cents) {
          if (window.theme && typeof window.theme.formatMoney === 'function') {
            return window.theme.formatMoney(cents, this.moneyFormat);
          }
          var dollars = (Number(cents) / 100).toFixed(2);
          return '$' + dollars;
        },

        /* Price getters bound by the reactive `price` snippet: a picked
           variant shows its single price; with no pick, the product range.
           Mirror snippets/price.liquid — keep in sync. */
        get isRange() {
          return !this.selectedVariant && !!(this.productPayload && this.productPayload.price_varies);
        },

        get isOnSale() {
          var v = this.selectedVariant;
          if (v) {
            return v.compare_at_price != null && Number(v.compare_at_price) > Number(v.price);
          }
          var p = this.productPayload;
          if (!p) return false;
          var floorDrop = p.compare_at_price_min > 0 && p.price_min < p.compare_at_price_min;
          if (!p.price_varies) return floorDrop;
          var ceilingDrop = p.compare_at_price_max > p.price_max;
          return floorDrop || ceilingDrop;
        },

        get displayPrice() {
          var v = this.selectedVariant;
          if (v) return this.formatMoney(v.price);
          var p = this.productPayload;
          if (!p) return '';
          if (p.price_varies) {
            return this.formatMoney(p.price_min) + ' - ' + this.formatMoney(p.price_max);
          }
          return this.formatMoney(p.price);
        },

        /* Members block visibility. With no pick, the product-level state -
           but only for an ungated offer (the projection walk already proved
           no variant is marked down); a variant-targeted offer advertises
           nothing until a pick lands inside its gate, matching the PDP and
           the members badge's gated wrapper. Once picked, the variant must be
           full price AND inside the discount's variant gate - the same two
           conditions the colour grid applies per card. */
        get showMembersPrice() {
          if (this.membersPercentage <= 0) return false;
          var variant = this.selectedVariant;
          if (!variant) return this.membersGateVariantIds.length === 0;
          if (variant.compare_at_price != null && Number(variant.compare_at_price) > Number(variant.price)) {
            return false;
          }
          return this.isMembersVariant(variant);
        },

        /* Members figure. Math.round matches the Liquid `| round` in
           members-price and the colour grid's repaint, so all three print the
           same cent. */
        get displayMembersPrice() {
          var members = function (cents) {
            return Math.round((Number(cents) * (100 - this.membersPercentage)) / 100);
          }.bind(this);
          var variant = this.selectedVariant;
          if (variant) return this.formatMoney(members(variant.price));
          var payload = this.productPayload;
          if (!payload) return '';
          if (payload.price_varies) {
            return (
              this.formatMoney(members(payload.price_min)) +
              ' - ' +
              this.formatMoney(members(payload.price_max))
            );
          }
          return this.formatMoney(members(payload.price));
        },

        get displayCompare() {
          var v = this.selectedVariant;
          if (v) {
            if (v.compare_at_price == null) return '';
            return this.formatMoney(v.compare_at_price);
          }
          var p = this.productPayload;
          if (!p) return '';
          if (p.price_varies) {
            return this.formatMoney(p.compare_at_price_min) + ' - ' + this.formatMoney(p.compare_at_price_max);
          }
          return this.formatMoney(p.compare_at_price);
        },

        /* Percent-off badge label. A picked variant shows its own floored "X%
           Off" (mirrors sale-badge), falling back to the members percentage
           when it carries no markdown and is in the gate, hidden when neither
           applies; with none picked, the whole-product "Up To" label. Integer
           maths to match the Liquid `divided_by` floor, and the same
           markdown-first precedence `sale-badge` applies. */
        get saleBadgeLabel() {
          var variant = this.selectedVariant;
          if (variant) {
            var compare = Number(variant.compare_at_price);
            var price = Number(variant.price);
            if (Number.isFinite(compare) && compare > price) {
              var percentOff = Math.floor(((compare - price) * 100) / compare);
              if (percentOff > 0) return this.saleLabelTemplate.replace('__PERCENT__', percentOff);
            }
            if (this.membersPercentage > 0 && this.isMembersVariant(variant)) {
              return this.saleLabelTemplate.replace('__PERCENT__', this.membersPercentage);
            }
            return '';
          }
          return this.saleProductLabel || '';
        },

        /* Variant-level flag badges. A picked variant governs - the flag shows
           only while its id is listed. With none picked the whole-product seed
           baseline governs (Exclusive / Online only iff every variant carries it,
           Clearance iff any), matching the SSR seed and the card / PDP. */
        flagActiveFor: function (ids, seed) {
          var v = this.selectedVariant;
          if (!v) return seed;
          return ids.indexOf(String(v.id)) !== -1;
        },
        get flagExclusive() {
          return this.flagActiveFor(this.flagExclusiveIds, this.flagSeedExclusive);
        },
        get flagClearance() {
          return this.flagActiveFor(this.flagClearanceIds, this.flagSeedClearance);
        },
        get flagOnlineOnly() {
          return this.flagActiveFor(this.flagOnlineOnlyIds, this.flagSeedOnlineOnly);
        },

        /* Variant-targeted members offer: only the listed variants may show
           the members percentage. Empty gate = every variant covered. */
        isMembersVariant: function (variant) {
          if (this.membersGateVariantIds.length === 0) return true;
          return this.membersGateVariantIds.indexOf(String(variant.id)) !== -1;
        },

        collectCheckedSorted: function () {
          return Array.from(
            this.$root.querySelectorAll('[data-quick-add-option-input]:checked')
          ).sort(function (a, b) {
            return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition);
          });
        },

        /* Delegate variant lookups to the shared `variantUtils` module so
           the QV picker stays byte-for-byte compatible with the PDP
           `$store.pdp` behaviour. The utils are loaded via
           layout/theme.liquid before Alpine, so they exist whenever
           this factory runs. */
        resolveVariantFromValues: function (values) {
          var utils = window.theme && window.theme.variantUtils;
          if (!utils) return null;
          return utils.resolveVariantFromValues(this.productPayload, values);
        },

        buildSelection: function () {
          var checked = this.$root.querySelectorAll('[data-quick-add-option-input]:checked');
          var selection = {};
          checked.forEach(function (input) {
            selection[input.dataset.optionPosition] = input.dataset.optionValue;
          });
          return selection;
        },

        /* Grey out option values that couldn't produce a real variant
           given the shopper's other picks. Mirrors the PDP picker
           behaviour so a shopper flipping through the QV drawer sees
           the same reachability rules they'd see on the PDP. Uses
           `pill--unavailable` / `swatch--unavailable` modifiers on
           the labels, and disables the underlying radio so keyboard
           nav can still discover but not select. */
        refreshAvailability: function () {
          /* Single-option colour products: every rendered swatch value has an
             uncapped colour-map entry, so all are reachable/selectable. Enable
             them and clear any `--unavailable` state (the `--oos` sold-out
             strike is server-rendered and stays). This bypasses the capped
             `hasVariantForPartial` payload check that wrongly muted tail
             colours whose variant sits past the 250-cap. */
          if (this.colourVariantMap.size > 0) {
            this.$root.querySelectorAll('[data-quick-add-option-input]').forEach(function (input) {
              var reachable = this.colourVariantMap.has(input.dataset.optionValue);
              input.disabled = !reachable;
              input.setAttribute('aria-disabled', reachable ? 'false' : 'true');
              var label = input.closest('[data-quick-add-option-label]');
              if (!label) return;
              label.classList.toggle(
                'quick-add__swatch--unavailable',
                !reachable && label.classList.contains('quick-add__swatch')
              );
              label.classList.toggle(
                'quick-add__pill--unavailable',
                !reachable && label.classList.contains('quick-add__pill')
              );
            }.bind(this));
            return;
          }

          var utils = window.theme && window.theme.variantUtils;
          if (!utils || !this.productPayload) return;
          var selection = this.buildSelection();
          this.$root.querySelectorAll('[data-quick-add-option-input]').forEach(function (input) {
            var testSelection = Object.assign({}, selection, {});
            testSelection[input.dataset.optionPosition] = input.dataset.optionValue;
            var viable = utils.hasVariantForPartial(this.productPayload, testSelection);
            input.disabled = !viable;
            input.setAttribute('aria-disabled', viable ? 'false' : 'true');
            var label = input.closest('[data-quick-add-option-label]');
            if (!label) return;
            label.classList.toggle(
              'quick-add__pill--unavailable',
              !viable && label.classList.contains('quick-add__pill')
            );
            label.classList.toggle(
              'quick-add__swatch--unavailable',
              !viable && label.classList.contains('quick-add__swatch')
            );
          }.bind(this));
        },

        findVariant: function (id) {
          if (!this.productPayload || !id) return null;
          var idNum = Number(id);
          for (var i = 0; i < this.productPayload.variants.length; i++) {
            if (this.productPayload.variants[i].id === idNum) return this.productPayload.variants[i];
          }
          return null;
        },

        onOptionChange: function () {
          var inputs = this.collectCheckedSorted();
          var self = this;

          /* Update every group's legend — selected groups show their value,
             now-empty groups (after a deselect) revert to the placeholder. */
          this.$root.querySelectorAll('[data-quick-add-option-display]').forEach(function (display) {
            var pos = display.dataset.quickAddOptionDisplay;
            var checked = self.$root.querySelector(
              '[data-quick-add-option-input][data-option-position="' + pos + '"]:checked'
            );
            if (checked) {
              display.textContent = checked.dataset.optionValue;
              display.classList.remove('quick-add__option-value--empty');
            } else {
              display.textContent = display.dataset.placeholder || '';
              display.classList.add('quick-add__option-value--empty');
            }
          });

          var totalOptions = this.$root.querySelectorAll('[data-quick-add-options] fieldset[data-option-position]').length;
          var complete = inputs.length === totalOptions;
          this.$root.setAttribute('data-quick-add-selection', complete ? 'complete' : 'incomplete');

          this.refreshAvailability();

          if (!complete) {
            /* Incomplete → show the range. */
            this.selectedVariant = null;
            this.selectedColourEntry = null;
            this.applyCtaLabel();
            return;
          }

          var values = inputs.map(function (input) { return input.dataset.optionValue; });

          /* Resolution order: the capped `productPayload` first (it carries the
             full variant object needed for the reactive price + SKU), then the
             UNCAPPED colour map for single-option products so a tail colour
             past the 250-cap still resolves an id, stock state and MOQ. When
             only the colour map resolves, `match` stays null and the price
             falls back to the product range — but the id, CTA and cart add all
             work off the map entry. */
          var match = this.resolveVariantFromValues(values);
          var colourEntry =
            this.colourVariantMap.size > 0 && values.length === 1
              ? this.colourVariantMap.get(values[0]) || null
              : null;
          this.selectedColourEntry = colourEntry;
          var resolvedId = match ? match.id : colourEntry ? colourEntry.id : null;

          if (resolvedId) {
            this.setVariantId(resolvedId);
            var hidden = this.$root.querySelector('[data-quick-add-variant-id]');
            if (hidden) hidden.value = String(resolvedId);

            var sku = this.$root.querySelector('[data-quick-add-sku]');
            var skuLabel = this.$root.querySelector('[data-quick-add-sku-label]');
            if (sku) {
              if (match && match.sku) {
                sku.textContent = match.sku;
                sku.hidden = false;
                if (skuLabel) skuLabel.hidden = false;
              } else {
                /* No payload variant (tail colour past the cap) or no SKU
                   (OOS placeholder / draft) — hide the pair rather than
                   leaving the previous variant's SKU stale in the meta row. */
                sku.textContent = '';
                sku.hidden = true;
                if (skuLabel) skuLabel.hidden = true;
              }
            }

            /* Drive the reactive price. Null for a tail colour → the getters
               fall back to the product range. */
            this.selectedVariant = match;

            var colourEl = this.$root.querySelector('[data-quick-add-colour]');
            var colourDivider = this.$root.querySelector('[data-quick-add-colour-divider]');
            var colourLabel = this.$root.querySelector('[data-quick-add-colour-label]');
            if (colourEl) {
              var pickedColour = '';
              for (var k = 0; k < inputs.length; k++) {
                var nm = (inputs[k].closest('[data-option-name]') || {}).dataset || {};
                var optName = (nm.optionName || '').toLowerCase();
                if (optName === 'color' || optName === 'colour') { pickedColour = inputs[k].dataset.optionValue; break; }
              }
              if (pickedColour) {
                colourEl.textContent = pickedColour;
                colourEl.hidden = false;
                if (colourDivider) colourDivider.hidden = false;
                if (colourLabel) colourLabel.hidden = false;
              }
            }

            this.applyVariantMax();

            /* Broadcast the picked variant so any document-level listeners
               (e.g. the wishlist button rendered inside this same drawer)
               can refresh their per-variant state. Mirrors the main
               product-variant-picker's dispatch — without it, the drawer's
               wishlist heart stayed stuck on the initially-rendered
               variant's fill state. */
            this.$root.dispatchEvent(new CustomEvent('variant:change', {
              detail: { variant: match, productId: this.productPayload && this.productPayload.id },
              bubbles: true,
            }));
          } else {
            /* Complete but no matching variant → revert to the range. */
            this.selectedVariant = null;
            this.$root.dispatchEvent(new CustomEvent('variant:change', {
              detail: { variant: null },
              bubbles: true,
            }));
          }

          this.applyCtaLabel();
        },

        setVariantId: function (id) {
          this.variantId = Number(id);
        },

        applyVariantMax: function () {
          var qty = this.$root.querySelector('.quantity-selector');
          if (!qty) return;
          var idStr = this.variantId != null ? String(this.variantId) : '';
          var cap;
          var rule;
          /* Single-option colour pick: the uncapped map entry owns the MOQ +
             cap so a tail colour past the 250-cap gets the right rule; the
             capped `variantMaxMap` / `variantMoqMap` wouldn't hold its id. */
          var entry = this.selectedColourEntry;
          if (entry) {
            cap = entry.max === Infinity ? '' : entry.max;
            rule = { min: entry.min, step: entry.step };
          } else {
            cap = idStr && this.variantMaxMap.has(idStr) ? this.variantMaxMap.get(idStr) : '';
            rule = idStr && this.variantMoqMap.has(idStr) ? this.variantMoqMap.get(idStr) : { min: 1, step: 1 };
          }
          this.moqMin = rule.min;
          this.moqStep = rule.step;
          qty.dispatchEvent(new CustomEvent('quantity:set-rule', { detail: { min: rule.min, step: rule.step, max: cap } }));
          this.updateMoqNotice(rule.min);
        },

        /* Show/update or hide the "multiples of N" banner for the picked
           variant, using the localised template on the form wrapper. */
        updateMoqNotice: function (min) {
          var banner = this.$root.querySelector('[data-quick-add-moq-banner]');
          if (!banner) return;
          var form = this.$root.querySelector('[data-quick-add-form]');
          var template = form ? form.dataset.moqMultiplesTemplate || '' : '';
          if (this.selectedVariant && min > 1 && template) {
            banner.textContent = template.replace('__MIN__', min);
            banner.classList.remove('quick-add__moq-banner--hidden');
          } else {
            banner.classList.add('quick-add__moq-banner--hidden');
          }
        },

        applyCtaLabel: function () {
          var cta = this.$root.querySelector('[data-quick-add-cta]');
          if (!cta) return;
          var labelNode = cta.querySelector('.button__label');
          var buttonEl = cta.querySelector('button, [type="submit"]');
          if (!labelNode || !buttonEl) return;

          var fieldsets = Array.from(
            this.$root.querySelectorAll('[data-quick-add-options] fieldset[data-option-position]')
          ).sort(function (a, b) {
            return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition);
          });

          var nextUnselected = fieldsets.find(function (fs) {
            return !fs.querySelector('input[type="radio"]:checked');
          });

          var label;
          var disabled = true;
          var stateAttr = '';

          var variantIdStr = this.variantId != null ? String(this.variantId) : '';
          /* Single-option colour pick: the uncapped map entry owns the
             disabled-state signals (a tail colour past the 250-cap is absent
             from the capped `hazardousBlockedIds` / `belowMoqIds` / `oosIds`
             sets, so reading those would wrongly enable it). */
          var entry = this.selectedColourEntry;
          var hazardousBlocked = entry
            ? entry.hazBlocked
            : variantIdStr !== '' && this.hazardousBlockedIds.has(variantIdStr);

          if (hazardousBlocked) {
            label = this.ctaLabels.hazardousBlocked;
            stateAttr = 'hazardous-blocked';
          } else if (nextUnselected) {
            var optionName = nextUnselected.dataset.optionName || '';
            label = this.ctaLabels.selectTemplate.replace('__OPTION__', optionName);
          } else {
            /* Liquid-rendered oosIds replaces the payload's
               `variant.available` — always true under native CONTINUE. */
            var belowMoq = entry
              ? entry.belowMoq
              : variantIdStr !== '' && this.belowMoqIds.has(variantIdStr);
            var unavailable = entry
              ? entry.oos
              : variantIdStr !== '' && this.oosIds.has(variantIdStr);
            if (belowMoq || unavailable) {
              label = this.ctaLabels.soldOut;
              stateAttr = 'below-moq';
            } else {
              label = this.ctaLabels.default;
              disabled = false;
            }
          }

          labelNode.textContent = label;
          if (disabled) {
            buttonEl.setAttribute('disabled', 'true');
            buttonEl.setAttribute('aria-disabled', 'true');
          } else {
            buttonEl.removeAttribute('disabled');
            buttonEl.removeAttribute('aria-disabled');
          }
          if (stateAttr) {
            this.$root.setAttribute('data-quick-add-state', stateAttr);
          } else {
            this.$root.setAttribute('data-quick-add-state', 'ready');
          }

          var qtyRoot = this.$root.querySelector('.quantity-selector');
          if (qtyRoot) {
            if (disabled) {
              qtyRoot.setAttribute('data-disabled', '');
              qtyRoot.querySelectorAll('input, button').forEach(function (n) { n.setAttribute('disabled', 'true'); });
            } else {
              qtyRoot.removeAttribute('data-disabled');
              qtyRoot.querySelectorAll('input, button').forEach(function (n) { n.removeAttribute('disabled'); });
            }
          }

          this.updateRestrictionNotices();
          /* Re-evaluate the MOQ banner on every option change (incl. a
             deselect back to an incomplete state), mirroring the restriction
             notices — `updateMoqNotice` hides it while `selectedVariant` is
             null. `applyVariantMax` also calls it on a complete pick, but only
             that path runs there, so this covers the incomplete / no-match
             paths that would otherwise leave a stale banner showing. */
          this.updateMoqNotice(this.moqMin);
        },

        /* Show/hide the bulky + hazardous notices for the picked variant.
           Hidden until a complete variant is resolved; membership in the
           id sets drives visibility from there. */
        updateRestrictionNotices: function () {
          var hasPick = !!this.selectedVariant;
          var variantIdStr = this.variantId != null ? String(this.variantId) : '';
          var isBulky = hasPick && variantIdStr !== '' && this.bulkyIds.has(variantIdStr);
          var isHazardous = hasPick && variantIdStr !== '' && this.hazardousIds.has(variantIdStr);
          var bulkyNotice = this.$root.querySelector('[data-restriction-notice="bulky"]');
          var hazardNotice = this.$root.querySelector('[data-restriction-notice="hazardous"]');
          if (bulkyNotice) bulkyNotice.classList.toggle('quick-add__notice--hidden', !isBulky);
          if (hazardNotice) hazardNotice.classList.toggle('quick-add__notice--hidden', !isHazardous);
        },

        onSubmit: function (event, form) {
          event.preventDefault();
          var self = this;
          var submitButton = form.querySelector('[type="submit"]');
          if (submitButton) submitButton.setAttribute('disabled', 'true');

          var body = new FormData(form);
          /* atc_context for the drawer add — the originating card was stashed
             on the drawer at open time; publish before the add so the pixel
             attributes the resulting add_to_cart to its list. */
          var drawerEl = self.$root.closest('dialog');
          var originCard = drawerEl && drawerEl.__atcOriginCard;
          if (originCard && window.theme && window.theme.trackAtcContext) {
            window.theme.trackAtcContext(originCard, self.variantId);
          }
          var variantIdNum = Number(self.variantId);
          var requestedQty = Number(body.get('quantity')) || 1;
          /* Per-variant ceiling (stock / MOQ max) from the drawer store. No
             entry means the variant oversells freely and takes the direct-add
             path; an entry caps how many may sit in the cart. */
          var idStr = String(self.variantId);
          var cap = self.variantMaxMap && self.variantMaxMap.has(idStr) ? self.variantMaxMap.get(idStr) : null;

          /* Post the add for `finalQty`, then fan out the toast + pixel events.
             Serialised cart write (see theme-globals cartAdd) so quick-add
             can't race the PDP / colour-card adds into a 409. cartAdd rejects
             with an Error carrying `.status` + `.body`, matching the shape the
             old inline handler threw. `capped` drives the all-in-bag toast. */
          function runAdd(finalQty, capped) {
            body.set('quantity', finalQty);
            window.theme
              .cartAdd(body)
              .then(function (payload) {
                self.$root.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { item: payload, cappedTo: capped ? cap : null } }));
                self.$root.dispatchEvent(new CustomEvent('product:added', {
                  bubbles: true,
                  detail: {
                    productHandle: self.productPayload && self.productPayload.handle,
                    variantId: self.variantId,
                    quantity: finalQty,
                  },
                }));
              })
              .catch(function (error) {
                self.$root.dispatchEvent(new CustomEvent('cart:add:error', { bubbles: true, detail: { error: error } }));
              })
              .finally(function () {
                if (submitButton) submitButton.removeAttribute('disabled');
              });
          }

          if (cap == null) {
            runAdd(requestedQty, false);
            return;
          }

          /* Capped variant: clamp the requested quantity to what's still
             addable (cap minus what's already in the cart across all its
             lines) BEFORE the post, so the add never lands with an over-cap
             quantity and the bag badge can't flash a number above the ceiling. */
          fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              var lines = cart && Array.isArray(cart.items) ? cart.items : [];
              var matching = lines.filter(function (line) { return Number(line.id) === variantIdNum; });
              var alreadyInCart = matching.reduce(function (sum, line) { return sum + (Number(line.quantity) || 0); }, 0);
              var addable = cap - alreadyInCart;
              if (addable <= 0) {
                /* Ceiling already met — add nothing (a post would only inflate
                   the badge before the cart clamps it back). Still surface the
                   all-in-bag toast off the existing cart line, and skip
                   `product:added` so no phantom add_to_cart is tracked. */
                var existing = matching[0] || { product_title: '' };
                self.$root.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { item: existing, cappedTo: cap } }));
                if (submitButton) submitButton.removeAttribute('disabled');
                return;
              }
              runAdd(Math.min(requestedQty, addable), requestedQty > addable);
            })
            .catch(function () {
              /* Cart read failed — fall back to the unclamped add so a network
                 blip never blocks a legitimate purchase. */
              runAdd(requestedQty, false);
            });
        },
      };
    });
  });

  /* Keyboard activation parity with PDP variant picker — `<label>` is in the
     tab order via tabindex=0, so we forward Enter/Space to the inner radio. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var label = event.target.closest('[data-quick-add-option-label]');
    if (!label) return;
    event.preventDefault();
    var input = label.querySelector('[data-quick-add-option-input]');
    if (!input || input.disabled) return;
    if (input.checked) {
      /* Pills can be toggled off; other option types stay select-only. */
      if (!label.classList.contains('quick-add__pill')) return;
      input.checked = false;
    } else {
      input.checked = true;
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  (function () {
    var ENDPOINT = '/products/{handle}?view=quick-add&sections=quick-add-form';
    var SECTION_ID = 'quick-add-form';
    var inFlight = null;
    var currentHandle = null;
    /* Remember the element that opened the drawer so we can blur it on
       close. Native `<dialog>.showModal()` returns focus to the opener,
       which on a product-card CTA keeps the hover/focus-revealed slide-up
       button visually pinned until the user clicks elsewhere. Blurring
       removes the `:focus-visible` state without breaking accessibility —
       focus still returns to the card, just not to the CTA element. */
    var lastTrigger = null;

    function getDrawer() {
      return document.getElementById('quick-add-drawer');
    }

    function setState(drawer, state) {
      var inner = drawer.querySelector('[data-quick-add]');
      if (!inner) return;
      inner.setAttribute('data-quick-add-state', state);
    }

    var reducedMotion = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;

    /* Height tracking for the currently-open drawer. */
    var heightObserver = null;
    var heightAnim = null;

    function disconnectHeightObserver() {
      if (heightObserver) {
        heightObserver.disconnect();
        heightObserver = null;
      }
    }

    /* Full reset: stop tracking, cancel the animation, restore `auto`. Run only
       while closed (on reopen). On close we just `disconnectHeightObserver()`
       and leave the height frozen so the exit never animates it. */
    function stopHeightTracking(dialog) {
      disconnectHeightObserver();
      if (heightAnim) {
        heightAnim.cancel();
        heightAnim = null;
      }
      if (dialog) dialog.style.height = '';
    }

    /* Match the height animation to the shared motion tokens. */
    function heightTiming() {
      var root = window.getComputedStyle(document.documentElement);
      var rawDuration = root.getPropertyValue('--transition-duration').trim();
      var easing = root.getPropertyValue('--transition-easing').trim() || 'ease';
      var duration = 300;
      if (rawDuration.slice(-2) === 'ms') duration = parseFloat(rawDuration);
      else if (rawDuration.slice(-1) === 's') duration = parseFloat(rawDuration) * 1000;
      return { duration: isNaN(duration) ? 300 : duration, easing: easing };
    }

    /* Ease the dialog to fit the fetched content once it replaces the skeleton.

       Animate via the Web Animations API, not a CSS `height` transition: a JS-
       driven height transition is honoured by WebKit but silently snapped by
       Chromium, whereas `dialog.animate()` interpolates explicit keyframes
       reliably in both.

       The injected content keeps reflowing for a beat (most visibly the Lora
       title's late web-font swap), so a ResizeObserver on the content re-runs
       the animation toward the new natural height on every reflow. We observe
       the content — not the dialog — so animating height can't feed back into
       the measurement. */
    function animateDialogHeight(dialog, mutate) {
      if (reducedMotion && reducedMotion.matches) {
        mutate();
        return;
      }
      stopHeightTracking(dialog);

      var start = dialog.offsetHeight;
      mutate();

      var body = dialog.querySelector('[data-quick-add-body]');
      var content = body ? body.firstElementChild : null;
      if (!content || typeof dialog.animate !== 'function') {
        /* Nothing measurable, or no Web Animations API: skip the tween and
           hand back to natural sizing. */
        dialog.style.height = '';
        return;
      }

      var header = dialog.querySelector('.quick-add-drawer__header');
      var timing = heightTiming();
      var target = start;

      var measure = function () {
        var maxHeight = parseFloat(window.getComputedStyle(dialog).maxHeight);
        /* `body.scrollHeight` is the full content height even when clipped, so
           header + that is the natural height whatever the section injected. */
        var natural = (header ? header.offsetHeight : 0) + body.scrollHeight;
        if (!isNaN(maxHeight)) natural = Math.min(natural, maxHeight);
        return natural;
      };

      var easeTo = function (from, to) {
        if (heightAnim) heightAnim.cancel();
        /* Resting height, so the dialog holds once the animation ends. */
        dialog.style.height = to + 'px';
        heightAnim = dialog.animate(
          [{ height: from + 'px' }, { height: to + 'px' }],
          { duration: timing.duration, easing: timing.easing }
        );
      };

      target = measure();
      easeTo(start, target);

      if (typeof ResizeObserver !== 'undefined') {
        heightObserver = new ResizeObserver(function () {
          var next = measure();
          if (Math.abs(next - target) < 1) return;
          var from = dialog.offsetHeight;
          target = next;
          easeTo(from, next);
        });
        heightObserver.observe(content);
      }
    }

    function clearBody(drawer) {
      /* Tear down height tracking and drop the inline height so the next open
         starts from a clean `auto`. */
      stopHeightTracking(drawer);
      var body = drawer.querySelector('[data-quick-add-body]');
      if (!body) return;
      body.innerHTML =
        '<div class="quick-add" data-quick-add data-quick-add-state="idle">' +
        '<div class="quick-add__skeleton" aria-hidden="true">' +
          '<div class="quick-add__skeleton-title"></div>' +
          '<div class="quick-add__skeleton-price"></div>' +
          '<div class="quick-add__skeleton-sku"></div>' +
          '<div class="quick-add__skeleton-grid">' +
            '<span></span><span></span><span></span>' +
            '<span></span><span></span><span></span>' +
          '</div>' +
        '</div>' +
        '<p class="quick-add__loading" data-quick-add-loading></p>' +
        '<div class="quick-add__error" data-quick-add-error hidden>' +
          '<p class="quick-add__error-message"></p>' +
          '<button type="button" class="button button--outline button--black button--md quick-add__retry" data-quick-add-retry></button>' +
        '</div></div>';
    }

    function showError(drawer, message, retryLabel) {
      var inner = drawer.querySelector('[data-quick-add]');
      if (!inner) return;
      var errorEl = inner.querySelector('[data-quick-add-error]');
      var msgEl = errorEl && errorEl.querySelector('.quick-add__error-message');
      var retryEl = errorEl && errorEl.querySelector('[data-quick-add-retry]');
      if (msgEl && message) msgEl.textContent = message;
      if (retryEl && retryLabel) retryEl.textContent = retryLabel;
      if (errorEl) errorEl.hidden = false;
      setState(drawer, 'error');
    }

    function fetchAndInject(drawer, handle) {
      if (inFlight) inFlight.abort();
      var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      inFlight = controller;

      setState(drawer, 'loading');

      var url = ENDPOINT.replace('{handle}', encodeURIComponent(handle));

      /* No `Accept: application/json` header — Shopify's dev server (and
         live too) treats that as a hint to return `/products/<handle>.json`
         (the product payload), not the Section Rendering API response.
         Without the header the JSON wrapper is still served because of the
         `?sections=` query param. */
      return fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        signal: controller ? controller.signal : undefined,
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Request failed (' + res.status + ')');
          return res.json();
        })
        .then(function (payload) {
          var html = payload && payload[SECTION_ID];
          if (typeof html !== 'string' || !html) throw new Error('Empty section payload');
          var body = drawer.querySelector('[data-quick-add-body]');
          if (!body) return;
          /* Strip the outer `<div class="shopify-section">` wrapper Shopify
             adds to Section Rendering API responses so the inner content
             slots directly into our body. */
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var section = temp.querySelector('.shopify-section') || temp;
          /* Swap skeleton → real content inside a height tween so the dialog
             eases to its new size instead of snapping. The new content owns
             its own `[data-quick-add-state="ready"]`. */
          animateDialogHeight(drawer, function () {
            body.innerHTML = '';
            while (section.firstChild) body.appendChild(section.firstChild);
          });
          inFlight = null;
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          inFlight = null;
          showError(
            drawer,
            drawer.dataset.errorMessage || 'We could not load this product. Please try again.',
            drawer.dataset.retryLabel || 'Try again'
          );
        });
    }

    function openDrawerFor(handle) {
      var drawer = getDrawer();
      if (!drawer) return;
      /* Remember which card opened the drawer so the submit handler can
         publish atc_context for the eventual add. */
      drawer.__atcOriginCard = lastTrigger ? lastTrigger.closest('[data-product-card]') : null;
      if (drawer.open && currentHandle === handle) return;
      currentHandle = handle;
      clearBody(drawer);
      if (typeof drawer.showModal === 'function' && !drawer.open) drawer.showModal();
      drawer.dispatchEvent(new CustomEvent('quick-add:open', { bubbles: true, detail: { handle: handle } }));
      fetchAndInject(drawer, handle);
    }

    /* When the card carries `data-quick-add-variant-id` (zero-option
       products with a resolved default variant), bypass the drawer and
       POST /cart/add.js directly. The quick-add drawer is otherwise
       redundant for these products — no options to choose, so opening
       a picker just adds a click. */
    function directAddFromTrigger(trigger) {
      var variantId = trigger.getAttribute('data-quick-add-variant-id');
      if (!variantId) return false;
      var variantIdNum = Number(variantId);
      var qty = Number(trigger.getAttribute('data-quick-add-quantity')) || 1;
      /* Per-variant ceiling (stock / MOQ max) rendered onto the card for the
         single-variant direct-add path, matching the PDP buy-buttons and the
         quick-add drawer. Absent means the variant oversells freely, so the
         add posts the requested qty unclamped. */
      var maxRaw = trigger.getAttribute('data-quick-add-max');
      var cap = maxRaw != null && maxRaw !== '' ? Number(maxRaw) : null;
      /* atc_context precedes the add so the pixel can attribute the
         resulting add_to_cart to this card's list. */
      var directCard = trigger.closest('[data-product-card]');
      if (directCard && window.theme && window.theme.trackAtcContext) {
        window.theme.trackAtcContext(directCard, variantId);
      }
      trigger.setAttribute('aria-busy', 'true');

      /* Serialised cart write so rapid card taps queue instead of racing into
         a 409. `capped` drives the all-in-bag toast wording. */
      function runAdd(finalQty, capped) {
        window.theme
          .cartAdd(JSON.stringify({ items: [{ id: variantIdNum, quantity: finalQty }] }))
          .then(function (payload) {
            var item = payload && Array.isArray(payload.items) ? payload.items[0] : payload;
            trigger.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { item: item, cappedTo: capped ? cap : null } }));
          })
          .catch(function (err) {
            /* 422s carry Shopify's error payload on err.body; network failures
               have none, so fall back to a detail-less event. */
            var detail = err && err.body ? { error: err.body } : {};
            trigger.dispatchEvent(new CustomEvent('cart:add:error', { bubbles: true, detail: detail }));
          })
          .finally(function () {
            trigger.removeAttribute('aria-busy');
          });
      }

      if (cap == null) {
        runAdd(qty, false);
        return true;
      }

      /* Capped variant: clamp the requested quantity to what's still addable
         (cap minus what's already in the cart across all its lines) BEFORE the
         post, so the add never lands over the ceiling and the bag badge can't
         flash a number above it. Read the live cart to learn the on-hand qty. */
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var lines = cart && Array.isArray(cart.items) ? cart.items : [];
          var matching = lines.filter(function (line) { return Number(line.id) === variantIdNum; });
          var alreadyInCart = matching.reduce(function (sum, line) { return sum + (Number(line.quantity) || 0); }, 0);
          var addable = cap - alreadyInCart;
          if (addable <= 0) {
            /* Ceiling already met — add nothing (a post would only inflate the
               badge before the cart clamps it back). Still surface the
               all-in-bag toast off the existing cart line. */
            var existing = matching[0] || { product_title: '' };
            trigger.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { item: existing, cappedTo: cap } }));
            trigger.removeAttribute('aria-busy');
            return;
          }
          runAdd(Math.min(qty, addable), qty > addable);
        })
        .catch(function () {
          /* Cart read failed — fall back to the unclamped add so a network
             blip never blocks a legitimate purchase. */
          runAdd(qty, false);
        });
      return true;
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-quick-add-trigger]');
      if (!trigger) return;
      event.preventDefault();
      lastTrigger = trigger;
      /* select_item — the quick-add click is a commitment gesture on the
         card, for both the direct add and the drawer path. */
      var card = trigger.closest('[data-product-card]');
      if (card && window.theme && window.theme.trackSelectItem) {
        window.theme.trackSelectItem(card);
      }
      if (directAddFromTrigger(trigger)) return;
      var handle = card && card.getAttribute('data-product-handle');
      if (!handle) return;
      openDrawerFor(handle);
    });

    document.addEventListener('click', function (event) {
      var retry = event.target.closest('[data-quick-add-retry]');
      if (!retry) return;
      var drawer = getDrawer();
      if (!drawer || !currentHandle) return;
      fetchAndInject(drawer, currentHandle);
    });

    /* On close, freeze the height (stop tracking but keep the inline px) so the
       exit doesn't animate it; the next open resets it via `clearBody` while
       closed. Also blur the opener, else the native `<dialog>` focus-return
       leaves the product-card CTA stuck in its focus-revealed state. */
    document.addEventListener('close', function (event) {
      var dialog = event.target;
      if (!dialog || dialog.id !== 'quick-add-drawer') return;
      if (inFlight) { inFlight.abort(); inFlight = null; }
      var handle = currentHandle;
      currentHandle = null;
      dialog.dispatchEvent(new CustomEvent('quick-add:close', { bubbles: true, detail: { handle: handle } }));
      disconnectHeightObserver();
      /* Defer the blur to the next tick so the browser's native focus-
         return finishes first; calling `.blur()` before that runs has no
         effect because focus hasn't returned yet. */
      var trigger = lastTrigger;
      lastTrigger = null;
      if (trigger && typeof trigger.blur === 'function') {
        window.requestAnimationFrame(function () { trigger.blur(); });
      }
    }, true);

    /* Close the drawer automatically after a successful add so the
       page-wide toast (mounted in the layout) becomes the next visible
       confirmation. Slight delay so the toast animation overlaps the
       drawer dismissal. */
    document.addEventListener('cart:add', function (event) {
      var drawer = getDrawer();
      if (!drawer || !drawer.open) return;
      var fromDrawer = event.target && (event.target === drawer || drawer.contains(event.target));
      if (!fromDrawer) return;
      window.setTimeout(function () {
        if (drawer.open) drawer.close();
      }, 300);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-order-save-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('quickOrderSaveDrawer', () => ({
      items: [],
      lists: [],
      newListName: '',
      creating: false,
      createError: '',
      // Labels hydrated from `data-qo-save-labels` on the root in init().
      handlers: null,
      itemsLabel(count) {
        const n = Number(count) || 0;
        return n + ' ' + (n === 1 ? 'item' : (this.itemsSuffix || 'items'));
      },
      hydrateLabels() {
        try {
          const raw = this.$root.dataset.qoSaveLabels;
          if (raw) {
            const decoder = document.createElement('textarea');
            const decode = (s) => { decoder.innerHTML = s; return decoder.value; };
            const parsed = JSON.parse(raw);
            for (const [k, v] of Object.entries(parsed)) {
              this[k] = typeof v === 'string' ? decode(v) : v;
            }
          }
        } catch (err) {
          console.warn('[quick-order-save-drawer] labels JSON parse failed:', err);
        }
      },
      async open(event) {
        this.items = (event && event.detail && Array.isArray(event.detail.items)) ? event.detail.items : [];
        this.newListName = '';
        this.createError = '';
        const dialog = document.getElementById('quick-order-save-drawer');
        if (dialog && typeof dialog.showModal === 'function') {
          try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
        } else if (dialog) {
          dialog.setAttribute('open', '');
        }
        try {
          const raw = await window.EckList.getLists();
          this.lists = (raw || []).map((l) => ({
            lid: l.lid,
            lname: l.lname,
            cnt: l.cnt || (Array.isArray(l.listcontents) ? l.listcontents.length : 0),
            pending: false,
          }));
        } catch (err) {
          this.lists = [];
        }
      },
      async addToList(list) {
        if (list.pending) return;
        if (!this.items.length) return;
        list.pending = true;
        try {
          let added = 0;
          for (const item of this.items) {
            try {
              await window.EckList.addProduct(list.lid, item);
              added++;
            } catch (e) {
              // Skip individual failures - Swym silently dedupes duplicates.
            }
          }
          list.added = true;
          document.dispatchEvent(new CustomEvent('wishlist:toast', {
            detail: {
              kind: 'added',
              origin: 'requisition',
              lid: list.lid,
              lname: list.lname,
              item: { dt: this.itemsLabel(added) },
              ctaLabel: this.viewListLabel,
              ctaUrl: '/pages/quick-order?lid=' + encodeURIComponent(list.lid),
            },
            bubbles: true,
          }));
        } finally {
          list.pending = false;
        }
      },
      /* Create the list and add every item in one go — no intermediate
         "create wishlist" modal. Keeps the whole flow (and its toast) in
         the requisition context so the confirmation reads "requisition
         list" / "View List", never "wishlist". */
      async createAndAdd() {
        if (this.creating) return;
        const name = String(this.newListName || '').trim();
        this.createError = '';
        if (name.length < 3) { this.createError = this.errorShort; return; }
        if (name.length > 50) { this.createError = this.errorLong; return; }
        const badChars = (window.EckList && window.EckList.listNameInvalidChars)
          ? window.EckList.listNameInvalidChars(name)
          : [];
        if (badChars.length) {
          this.createError = (this.errorInvalidChars || this.errorGeneric || '').replace('__CHARS__', badChars.join(' '));
          return;
        }
        if (!this.items.length) return;
        this.creating = true;
        try {
          const list = await window.EckList.createList({ name });
          if (!list || !list.lid) throw new Error('create-failed');
          let added = 0;
          for (const item of this.items) {
            try {
              await window.EckList.addProduct(list.lid, item);
              added++;
            } catch (e) {
              // Skip individual failures — Swym silently dedupes duplicates.
            }
          }
          document.dispatchEvent(new CustomEvent('wishlist:toast', {
            detail: {
              kind: 'added',
              origin: 'requisition',
              lid: list.lid,
              lname: list.lname,
              item: { dt: this.itemsLabel(added) },
              ctaLabel: this.viewListLabel,
              ctaUrl: '/pages/quick-order?lid=' + encodeURIComponent(list.lid),
            },
            bubbles: true,
          }));
          const dialog = document.getElementById('quick-order-save-drawer');
          if (dialog && typeof dialog.close === 'function') dialog.close();
        } catch (err) {
          console.warn('[quick-order-save-drawer] create-and-add failed:', err);
          this.createError = this.errorGeneric;
        } finally {
          this.creating = false;
        }
      },
      init() {
        this.hydrateLabels();
        const onOpen = (event) => this.open(event);
        document.addEventListener('wishlist:open-save-drawer', onOpen);
        this.handlers = { onOpen };
      },
      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('wishlist:open-save-drawer', this.handlers.onOpen);
        this.handlers = null;
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swatch"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('swatch', () => ({
      select() {
        const d = this.$root.dataset;
        this.$dispatch('swatch:change', {
          value: d.swatchValue,
          name: d.swatchName,
          type: d.swatchType,
          label: d.swatchLabel,
        });
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tab-group"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('tabGroup', () => ({
      onClick(event) {
        const item = event.target.closest('[data-tab-item]');
        if (!item) return;
        this.$dispatch('tab:change', {
          value: item.dataset.tabValue,
          label: item.dataset.tabLabel,
        });
      },
      onKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const current = event.target.closest('[data-tab-item]');
        if (!current) return;
        const items = Array.from(this.$root.querySelectorAll('[data-tab-item]:not([disabled])'));
        const idx = items.indexOf(current);
        if (idx === -1) return;
        const offset = event.key === 'ArrowRight' ? 1 : -1;
        const target = items[(idx + offset + items.length) % items.length];
        target.focus();
        event.preventDefault();
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tag"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('tag', () => ({
      remove() {
        if (this.$root.disabled) return;
        this.$dispatch('tag:remove', {
          value: this.$root.dataset.tagValue,
          label: this.$root.dataset.tagLabel,
        });
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast-banner"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('toastBanner', () => ({
      dismissing: false,
      timer: null,
      init() {
        const delay = Number(this.$root.dataset.autoDismissMs);
        if (delay > 0) this.timer = setTimeout(() => this.dismiss(), delay);
      },
      dismiss() {
        if (this.dismissing) return;
        this.dismissing = true;
        this.$dispatch('toast-banner:dismiss');
        this.$root.addEventListener('animationend', () => this.$root.remove(), { once: true });
      },
      destroy() {
        if (this.timer) clearTimeout(this.timer);
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toggle"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('toggle', () => ({
      emitChange(event) {
        const input = event.target;
        this.$dispatch('toggle:change', { checked: input.checked, name: input.name });
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-fallback-image"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'error',
    function (event) {
      var img = event.target;
      if (
        !img ||
        img.tagName !== 'IMG' ||
        !img.hasAttribute('data-variant-fallback-image')
      ) {
        return;
      }
      // The SKU file could be .png, .jpg or .jpeg. Try each src in turn on
      // load error; only remove the image once none of them load.
      var srcs = (img.getAttribute('data-fallback-srcs') || '')
        .split(' ')
        .filter(Boolean);
      var next = parseInt(img.getAttribute('data-fallback-index') || '0', 10) + 1;
      if (next < srcs.length) {
        img.setAttribute('data-fallback-index', String(next));
        img.src = srcs[next];
      } else {
        img.remove();
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('wishlistButton', () => ({
      added: false,
      pending: false,
      unavailable: false,
      addLabel: 'Add to wishlist',
      removeLabel: 'Remove from wishlist',
      handlers: null,
      readAttrs() {
        const btn = this.$root;
        const priceStr = btn.dataset.wishlistProductPrice || '';
        const price = priceStr ? Number(priceStr) : null;
        return {
          variantId: Number(btn.dataset.wishlistVariantId),
          productId: Number(btn.dataset.wishlistProductId),
          url: btn.dataset.wishlistProductUrl,
          title: btn.dataset.wishlistProductTitle || '',
          variantTitle: btn.dataset.wishlistVariantTitle || '',
          image: btn.dataset.wishlistProductImage || '',
          price: Number.isFinite(price) ? price : null,
        };
      },
      async syncFromBridge() {
        if (this.unavailable) return;
        if (!window.EckList) return;
        try {
          const { variantId } = this.readAttrs();
          if (!variantId) return;
          this.added = await window.EckList.isProductInAnyList(variantId);
        } catch (e) { /* silently ignore; bridge may not be ready */ }
      },
      async onClick() {
        if (this.pending || this.unavailable) return;
        if (!window.EckList) return;
        const attrs = this.readAttrs();
        if (!attrs.variantId || !attrs.productId || !attrs.url) return;

        // Guests can only have a single "Favourites" list, so the picker
        // adds no value: add silently to the default list, remove silently
        // from every list. Toast still fires so the action is visible.
        const isGuest = this.$root.dataset.wishlistSignedIn === '0';
        if (isGuest) {
          this.pending = true;
          try {
            if (this.added) {
              const lids = await window.EckList.productListMembership(attrs.variantId).catch(() => []);
              await Promise.all(lids.map((lid) => window.EckList.removeProduct(lid, attrs).catch(() => null)));
              document.dispatchEvent(new CustomEvent('wishlist:toast', {
                detail: {
                  variantId: attrs.variantId,
                  productId: attrs.productId,
                  url: attrs.url,
                  kind: 'removed',
                },
                bubbles: true,
              }));
              return;
            }
            // Guest add goes through Swym's default-wishlist path — the
            // SDK auto-creates the list on first write, so no separate
            // `getDefaultList({createIfMissing})` call is needed. The
            // returned `item.lid` is the guest's default wishlist id.
            const item = await window.EckList.addProduct(null, attrs);
            document.dispatchEvent(new CustomEvent('wishlist:toast', {
              detail: {
                variantId: attrs.variantId,
                productId: attrs.productId,
                url: attrs.url,
                lid: item && item.lid,
                kind: 'added',
                item,
              },
              bubbles: true,
            }));
          } catch (err) {
            console.warn('[wishlist-button] guest toggle failed:', err);
          } finally {
            this.pending = false;
          }
          return;
        }

        // Filled heart — open the picker so the shopper can toggle
        // membership across lists.
        if (this.added) {
          const prechecked = await window.EckList.productListMembership(attrs.variantId).catch(() => []);
          document.dispatchEvent(new CustomEvent('wishlist:open-picker', {
            detail: { ...attrs, prechecked },
            bubbles: true,
          }));
          return;
        }

        // Empty heart — always open the picker so a signed-in shopper
        // consciously chooses the destination list (or creates one).
        // Signed-in shoppers can own multiple lists, so a silent
        // default-add would hide that choice and mimic the guest flow.
        // With exactly one list we pre-check it so Save is one click;
        // with zero or many we pre-check nothing and let the picker's
        // empty state + always-present Create action take over. The
        // picker and its create-modal fire their own toasts.
        this.pending = true;
        try {
          const lists = await window.EckList.getLists();
          const prechecked = lists.length === 1 ? [lists[0].lid] : [];
          document.dispatchEvent(new CustomEvent('wishlist:open-picker', {
            detail: { ...attrs, prechecked },
            bubbles: true,
          }));
        } catch (err) {
          console.warn('[wishlist-button] open picker failed:', err);
        } finally {
          this.pending = false;
        }
      },
      // Keep this button's data-* attrs in sync with the PDP's current
      // variant. The variant picker dispatches `variant:change` with
      // `{ variant }` whenever the shopper picks a swatch/option. We
      // filter by product id so product-card wishlist buttons on the
      // same page (recommended products, related products) don't react
      // to the PDP's picker.
      onVariantChange(event) {
        const detail = event && event.detail;
        const variant = detail && detail.variant;
        if (!variant || variant.id == null) return;
        const btn = this.$root;
        const btnProductId = Number(btn.dataset.wishlistProductId);
        const eventProductId = Number(
          variant.product_id != null ? variant.product_id : detail.productId
        );
        if (!btnProductId || !eventProductId || eventProductId !== btnProductId) return;

        btn.dataset.wishlistVariantId = String(variant.id);
        // `title` is the variant's option combo (e.g. "Crimson Red / 8mL").
        // Shopify uses "Default Title" for single-variant products —
        // stripping it keeps the toast + wishlist card clean.
        const vt = variant.title && variant.title !== 'Default Title' ? variant.title : '';
        btn.dataset.wishlistVariantTitle = vt;
        // Price on Shopify's JS variant object is an integer of cents.
        if (typeof variant.price === 'number') {
          btn.dataset.wishlistProductPrice = (variant.price / 100).toString();
        }
        // Prefer the variant's own image over the product's featured.
        const varImage = variant.featured_image && variant.featured_image.src
          ? variant.featured_image.src
          : (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src)
            || '';
        if (varImage) btn.dataset.wishlistProductImage = varImage;

        // Refresh the filled/empty state for the new variant. Different
        // variants have independent wishlist membership — the crimson
        // ink could be on a list while the cobalt one isn't.
        this.syncFromBridge();
      },
      init() {
        // Pull user-facing labels out of the data-* attrs so we don't need
        // to escape strings into the x-data attribute value.
        const btn = this.$root;
        if (btn.dataset.wishlistAddLabel) this.addLabel = btn.dataset.wishlistAddLabel;
        if (btn.dataset.wishlistRemoveLabel) this.removeLabel = btn.dataset.wishlistRemoveLabel;

        const onReady = () => this.syncFromBridge();
        const onProductsChanged = (event) => {
          const { variantId } = this.readAttrs();
          if (!variantId) return;
          const detail = event && event.detail;
          if (!detail) return;
          const touched = (arr) => Array.isArray(arr) && arr.some((it) => it && Number(it.epi) === variantId);
          if (touched(detail.added) || touched(detail.removed)) this.syncFromBridge();
        };
        const onListsChanged = () => this.syncFromBridge();
        const onDegraded = () => { this.unavailable = true; this.added = false; };
        const onVariantChange = (event) => this.onVariantChange(event);

        if (window.EckList && window.EckList.mode === 'ready') onReady();
        if (window.EckList && window.EckList.mode === 'degraded') onDegraded();

        document.addEventListener('swym:ready', onReady);
        document.addEventListener('swym:products-changed', onProductsChanged);
        document.addEventListener('swym:lists-changed', onListsChanged);
        document.addEventListener('swym:degraded', onDegraded);
        document.addEventListener('variant:change', onVariantChange);
        this.handlers = { onReady, onProductsChanged, onListsChanged, onDegraded, onVariantChange };
      },
      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('swym:ready', this.handlers.onReady);
        document.removeEventListener('swym:products-changed', this.handlers.onProductsChanged);
        document.removeEventListener('swym:lists-changed', this.handlers.onListsChanged);
        document.removeEventListener('swym:degraded', this.handlers.onDegraded);
        document.removeEventListener('variant:change', this.handlers.onVariantChange);
        this.handlers = null;
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-count-badge"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('wishlistCountBadge', (initial) => ({
      count: Number(initial) || 0,
      unavailable: false,
      handlers: null,
      get isEmpty() {
        return this.unavailable || this.count <= 0;
      },
      init() {
        const onReady = () => {
          if (window.EckList && typeof window.EckList.count === 'function') {
            window.EckList.count().then((c) => {
              this.count = Number(c) || 0;
            }).catch(() => { /* stay at initial */ });
          }
        };
        const onCountChanged = (event) => {
          if (this.unavailable) return;
          const next = event && event.detail && event.detail.count;
          if (typeof next === 'number') this.count = next;
        };
        const onDegraded = () => {
          this.unavailable = true;
          this.count = 0;
        };
        // If the bridge is already ready when the badge mounts, hydrate immediately.
        if (window.EckList && window.EckList.mode === 'ready') onReady();
        if (window.EckList && window.EckList.mode === 'degraded') onDegraded();
        document.addEventListener('swym:ready', onReady);
        document.addEventListener('swym:count-changed', onCountChanged);
        document.addEventListener('swym:degraded', onDegraded);
        this.handlers = { onReady, onCountChanged, onDegraded };
      },
      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('swym:ready', this.handlers.onReady);
        document.removeEventListener('swym:count-changed', this.handlers.onCountChanged);
        document.removeEventListener('swym:degraded', this.handlers.onDegraded);
        this.handlers = null;
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-create-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('wishlistCreate', () => ({
      name: '',
      error: '',
      submitting: false,
      context: null,
      // Origin drawer, when opened from one that can be returned to (the
      // picker). Drives the Back button; empty for standalone opens.
      returnTo: '',
      // Labels hydrated from `data-wl-create-labels` on the root in init().
      handlers: null,
      get counterText() {
        return (this.counterTemplate || '').replace('__COUNT__', (this.name.length || 0));
      },
      hydrateLabels() {
        try {
          const raw = this.$root.dataset.wlCreateLabels;
          if (raw) {
            const decoder = document.createElement('textarea');
            const decode = (s) => { decoder.innerHTML = s; return decoder.value; };
            const parsed = JSON.parse(raw);
            for (const [k, v] of Object.entries(parsed)) {
              this[k] = typeof v === 'string' ? decode(v) : v;
            }
          }
        } catch (err) {
          console.warn('[wishlist-create] labels JSON parse failed:', err);
        }
      },
      syncSubmitLabel() {
        // The submit button is rendered by the shared `button` snippet which
        // outputs a <span class="button__label"> child. Mirror the current
        // label state (Create / Creating...) and disabled state onto that
        // node instead of duplicating the button markup.
        const button = this.$root.querySelector('.wishlist-create__submit');
        if (!button) return;
        const labelEl = button.querySelector('.button__label');
        // With a product to add (picker flow) the resting label reads "Add
        // Item to New Wishlist"; standalone creates keep the plain "Create".
        const ctx = this.context || {};
        const hasItem = !!(ctx.variantId || (ctx.followupItems && ctx.followupItems.length));
        const resting = hasItem ? this.submitWithItemLabel : this.submitLabel;
        const label = this.submitting ? this.submittingLabel : resting;
        if (labelEl && labelEl.textContent !== label) labelEl.textContent = label;
        const trimmed = String(this.name || '').trim();
        const invalid = this.submitting || trimmed.length < 3 || trimmed.length > 50;
        if (invalid) {
          button.setAttribute('disabled', '');
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
        }
      },
      open(event) {
        const detail = (event && event.detail) || {};
        // Full product context is preserved (title / variant / image / price
        // beyond the ids submit needs) so Back can reopen the picker intact.
        const price = typeof detail.price === 'number' && Number.isFinite(detail.price) ? detail.price : null;
        this.context = {
          variantId: detail.variantId ? Number(detail.variantId) : null,
          productId: detail.productId ? Number(detail.productId) : null,
          url: detail.url || '',
          title: detail.title || '',
          variantTitle: detail.variantTitle || '',
          image: detail.image || '',
          price: price,
          followupItems: Array.isArray(detail.followupItems) ? detail.followupItems : [],
        };
        this.returnTo = detail.returnTo || '';
        this.name = detail.prefillName ? String(detail.prefillName).slice(0, 50) : '';
        this.error = '';
        this.submitting = false;
        // Context just changed; refresh the resting label (the name watcher
        // won't fire when name is reset to the same empty string).
        this.syncSubmitLabel();
        const dialog = document.getElementById('wishlist-create-drawer');
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') {
          try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
        } else {
          dialog.setAttribute('open', '');
        }
        // Focus the input after the drawer transition settles.
        setTimeout(() => {
          if (this.$refs && this.$refs.input) this.$refs.input.focus();
        }, 100);
      },
      close() {
        const dialog = document.getElementById('wishlist-create-drawer');
        if (dialog && typeof dialog.close === 'function') dialog.close();
      },
      // Reopen the picker this drawer was launched from, carrying the same
      // product context. Only reachable when `returnTo === 'picker'`.
      back() {
        const ctx = this.context || {};
        this.close();
        document.dispatchEvent(new CustomEvent('wishlist:open-picker', {
          detail: {
            variantId: ctx.variantId,
            productId: ctx.productId,
            url: ctx.url,
            title: ctx.title,
            variantTitle: ctx.variantTitle,
            image: ctx.image,
            price: ctx.price,
          },
          bubbles: true,
        }));
      },
      async submit() {
        const trimmed = String(this.name || '').trim();
        if (trimmed.length < 3) { this.error = this.errorShort; return; }
        if (trimmed.length > 50) { this.error = this.errorLong; return; }
        const badChars = (window.EckList && window.EckList.listNameInvalidChars) ? window.EckList.listNameInvalidChars(trimmed) : [];
        if (badChars.length) { this.error = (this.errorInvalidChars || this.errorGeneric).replace('__CHARS__', badChars.join(' ')); return; }
        this.error = '';
        this.submitting = true;
        try {
          const list = await window.EckList.createList({ name: trimmed });
          const ctx = this.context || {};
          const hasProduct = ctx.variantId && ctx.productId && ctx.url;
          const followups = Array.isArray(ctx.followupItems) ? ctx.followupItems : [];
          if (list && list.lid) {
            let addedCount = 0;
            if (hasProduct) {
              const primary = await window.EckList.addProduct(list.lid, ctx).catch(() => null);
              if (primary) addedCount++;
            }
            for (const item of followups) {
              try {
                await window.EckList.addProduct(list.lid, item);
                addedCount++;
              } catch (e) { /* Swym silently dedupes; skip individual failures */ }
            }
            if (addedCount > 0) {
              document.dispatchEvent(new CustomEvent('wishlist:toast', {
                detail: {
                  lid: list.lid,
                  lname: list.lname,
                  kind: 'added',
                  item: addedCount === 1 && hasProduct
                    ? { dt: null, du: ctx.url, epi: ctx.variantId, empi: ctx.productId }
                    : { dt: addedCount + ' item' + (addedCount === 1 ? '' : 's') },
                },
                bubbles: true,
              }));
            } else {
              document.dispatchEvent(new CustomEvent('wishlist:created', {
                detail: { lid: list.lid, lname: list.lname },
                bubbles: true,
              }));
            }
          }
          this.close();
        } catch (err) {
          console.warn('[wishlist-create] create failed:', err);
          this.error = this.errorGeneric;
        } finally {
          this.submitting = false;
        }
      },
      init() {
        this.hydrateLabels();
        this.syncSubmitLabel();
        this.$watch('name', () => this.syncSubmitLabel());
        this.$watch('submitting', () => this.syncSubmitLabel());
        const onOpen = (event) => this.open(event);
        document.addEventListener('wishlist:open-create', onOpen);
        this.handlers = { onOpen };
      },
      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('wishlist:open-create', this.handlers.onOpen);
        this.handlers = null;
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-delete-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('wishlistDelete', () => ({
      lid: null,
      lname: '',
      error: '',
      submitting: false,
      // Labels hydrated from `data-wl-delete-labels` on the root in init().
      handlers: null,
      get bodyText() {
        return (this.bodyTemplate || '').replace('__NAME__', this.lname || '');
      },
      hydrateLabels() {
        try {
          const raw = this.$root.dataset.wlDeleteLabels;
          if (raw) {
            const decoder = document.createElement('textarea');
            const decode = (s) => { decoder.innerHTML = s; return decoder.value; };
            const parsed = JSON.parse(raw);
            for (const [k, v] of Object.entries(parsed)) {
              this[k] = typeof v === 'string' ? decode(v) : v;
            }
          }
        } catch (err) {
          console.warn('[wishlist-delete] labels JSON parse failed:', err);
        }
      },
      open(event) {
        const detail = (event && event.detail) || {};
        if (!detail.lid) return;
        this.lid = detail.lid;
        this.lname = String(detail.lname || '');
        this.error = '';
        this.submitting = false;
        const dialog = document.getElementById('wishlist-delete-drawer');
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') {
          try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
        } else {
          dialog.setAttribute('open', '');
        }
      },
      close() {
        const dialog = document.getElementById('wishlist-delete-drawer');
        if (dialog && typeof dialog.close === 'function') dialog.close();
      },
      async submit() {
        if (!this.lid || this.submitting) return;
        this.error = '';
        this.submitting = true;
        try {
          await window.EckList.deleteList(this.lid);
          document.dispatchEvent(new CustomEvent('wishlist:deleted', {
            detail: { lid: this.lid },
            bubbles: true,
          }));
          this.close();
        } catch (err) {
          console.warn('[wishlist-delete] delete failed:', err);
          this.error = this.errorGeneric;
        } finally {
          this.submitting = false;
        }
      },
      init() {
        this.hydrateLabels();
        const onOpen = (event) => this.open(event);
        document.addEventListener('wishlist:open-delete', onOpen);
        this.handlers = { onOpen };
      },
      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('wishlist:open-delete', this.handlers.onOpen);
        this.handlers = null;
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-edit-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('wishlistEdit', () => ({
      lid: null,
      originalName: '',
      name: '',
      error: '',
      submitting: false,
      // Labels hydrated from `data-wl-edit-labels` on the root in init().
      handlers: null,
      get counterText() {
        return (this.counterTemplate || '').replace('__COUNT__', (this.name.length || 0));
      },
      hydrateLabels() {
        try {
          const raw = this.$root.dataset.wlEditLabels;
          if (raw) {
            const decoder = document.createElement('textarea');
            const decode = (s) => { decoder.innerHTML = s; return decoder.value; };
            const parsed = JSON.parse(raw);
            for (const [k, v] of Object.entries(parsed)) {
              this[k] = typeof v === 'string' ? decode(v) : v;
            }
          }
        } catch (err) {
          console.warn('[wishlist-edit] labels JSON parse failed:', err);
        }
      },
      syncSubmitLabel() {
        const button = this.$root.querySelector('.wishlist-edit__submit');
        if (!button) return;
        const labelEl = button.querySelector('.button__label');
        const label = this.submitting ? this.submittingLabel : this.submitLabel;
        if (labelEl && labelEl.textContent !== label) labelEl.textContent = label;
        const trimmed = String(this.name || '').trim();
        const invalid = this.submitting || trimmed.length < 3 || trimmed.length > 50 || trimmed === this.originalName;
        if (invalid) {
          button.setAttribute('disabled', '');
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
        }
      },
      open(event) {
        const detail = (event && event.detail) || {};
        if (!detail.lid) return;
        this.lid = detail.lid;
        this.originalName = String(detail.lname || '');
        this.name = this.originalName.slice(0, 50);
        this.error = '';
        this.submitting = false;
        const dialog = document.getElementById('wishlist-edit-drawer');
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') {
          try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
        } else {
          dialog.setAttribute('open', '');
        }
        setTimeout(() => {
          if (this.$refs && this.$refs.input) {
            this.$refs.input.focus();
            this.$refs.input.select();
          }
        }, 100);
      },
      close() {
        const dialog = document.getElementById('wishlist-edit-drawer');
        if (dialog && typeof dialog.close === 'function') dialog.close();
      },
      async submit() {
        const trimmed = String(this.name || '').trim();
        if (trimmed.length < 3) { this.error = this.errorShort; return; }
        if (trimmed.length > 50) { this.error = this.errorLong; return; }
        if (trimmed === this.originalName) { this.close(); return; }
        const badChars = (window.EckList && window.EckList.listNameInvalidChars) ? window.EckList.listNameInvalidChars(trimmed) : [];
        if (badChars.length) { this.error = (this.errorInvalidChars || this.errorGeneric).replace('__CHARS__', badChars.join(' ')); return; }
        this.error = '';
        this.submitting = true;
        try {
          await window.EckList.renameList(this.lid, trimmed);
          document.dispatchEvent(new CustomEvent('wishlist:renamed', {
            detail: { lid: this.lid, lname: trimmed },
            bubbles: true,
          }));
          this.close();
        } catch (err) {
          console.warn('[wishlist-edit] rename failed:', err);
          this.error = this.errorGeneric;
        } finally {
          this.submitting = false;
        }
      },
      init() {
        this.hydrateLabels();
        this.syncSubmitLabel();
        this.$watch('name', () => this.syncSubmitLabel());
        this.$watch('submitting', () => this.syncSubmitLabel());
        const onOpen = (event) => this.open(event);
        document.addEventListener('wishlist:open-edit', onOpen);
        this.handlers = { onOpen };
      },
      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('wishlist:open-edit', this.handlers.onOpen);
        this.handlers = null;
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-header-icon"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('wishlistHeaderIcon', () => ({
      count: 0,
      unavailable: false,
      handlers: null,
      get isFilled() {
        return !this.unavailable && this.count > 0;
      },
      syncAriaLabel() {
        const label = this.$root.querySelector('[data-wishlist-header-icon-count-label]');
        if (!label) return;
        // Server renders the count as a digit; tokenise it once so we can
        // re-substitute the live wishlist count on later updates.
        try {
          const tpl = label.dataset.tpl || label.textContent.replace(/\d+/, '__count__');
          label.dataset.tpl = tpl;
          label.textContent = tpl.replace(/__count__/g, String(this.count));
        } catch { /* leave whatever server rendered */ }
      },
      hydrate() {
        if (this.unavailable) return;
        if (!window.EckList || typeof window.EckList.count !== 'function') return;
        window.EckList.count().then((c) => {
          this.count = Number(c) || 0;
          this.syncAriaLabel();
        }).catch(() => { /* leave at 0 */ });
      },
      init() {
        const onReady = () => this.hydrate();
        const onCountChanged = (event) => {
          if (this.unavailable) return;
          const next = event && event.detail && event.detail.count;
          if (typeof next === 'number') {
            this.count = next;
            this.syncAriaLabel();
          }
        };
        const onDegraded = () => {
          this.unavailable = true;
          this.count = 0;
        };
        if (window.EckList && window.EckList.mode === 'ready') onReady();
        if (window.EckList && window.EckList.mode === 'degraded') onDegraded();
        document.addEventListener('swym:ready', onReady);
        document.addEventListener('swym:count-changed', onCountChanged);
        document.addEventListener('swym:degraded', onDegraded);
        this.handlers = { onReady, onCountChanged, onDegraded };
      },
      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('swym:ready', this.handlers.onReady);
        document.removeEventListener('swym:count-changed', this.handlers.onCountChanged);
        document.removeEventListener('swym:degraded', this.handlers.onDegraded);
        this.handlers = null;
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-picker-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('wishlistPicker', () => ({
      loading: false,
      saving: false,
      lists: [],
      dropdownOpen: false,
      context: null, // { variantId, productId, url, prechecked, cartLineKey, saveForLater }
      // Cart save-for-later "move" bookkeeping (reset each open): `didAdd`
      // gates the removal on a successful add; `moved` makes it fire once.
      didAdd: false,
      moved: false,
      loadingLabel: 'Loading your wishlists...',
      emptyLabel: "You don't have any wishlists yet.",
      createLabel: 'Create new wishlist',
      saveLabel: 'Save',
      savingLabel: 'Saving...',
      handlers: null,
      get checkedCount() {
        return this.lists.filter((l) => l.checked).length;
      },
      // Save is meaningful only when the staged selection differs from
      // actual membership — this also catches unchecking an initially
      // checked list, whose removal `checkedCount > 0` would miss.
      get hasPendingChanges() {
        return this.lists.some((l) => l.checked !== l.initialChecked);
      },
      get triggerValue() {
        return this.lists
          .filter((l) => l.checked)
          .map((l) => l.lname)
          .join(', ');
      },
      hydrateLabels() {
        try {
          const raw = this.$root.dataset.wlPickerLabels;
          if (raw) {
            const decoder = document.createElement('textarea');
            const decode = (s) => { decoder.innerHTML = s; return decoder.value; };
            const parsed = JSON.parse(raw);
            for (const [k, v] of Object.entries(parsed)) {
              this[k] = typeof v === 'string' ? decode(v) : v;
            }
          }
        } catch (err) {
          console.warn('[wishlist-picker] labels JSON parse failed:', err);
        }
      },
      toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
      },
      closeDropdown() {
        this.dropdownOpen = false;
      },
      async open(event) {
        const detail = (event && event.detail) || {};
        const price = typeof detail.price === 'number' && Number.isFinite(detail.price) ? detail.price : null;
        this.context = {
          variantId: Number(detail.variantId),
          productId: Number(detail.productId),
          url: String(detail.url || ''),
          title: detail.title || '',
          variantTitle: detail.variantTitle || '',
          image: detail.image || '',
          price: price,
          prechecked: Array.isArray(detail.prechecked) ? detail.prechecked : [],
          cartLineKey: detail.cartLineKey ? String(detail.cartLineKey) : null,
          saveForLater: !!detail.saveForLater,
        };
        // Fresh session — no add has happened, no move has run.
        this.didAdd = false;
        this.moved = false;
        const dialog = document.getElementById('wishlist-picker-drawer');
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') {
          try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
        } else {
          dialog.setAttribute('open', '');
        }
        this.dropdownOpen = false;
        this.loading = true;
        try {
          const rawLists = await window.EckList.getLists();
          // `initialChecked` mirrors actual list membership — the source
          // of truth for the save-diff (toAdd / toRemove). Always fetched.
          const membership = new Set();
          if (this.context.variantId) {
            const active = await window.EckList.productListMembership(this.context.variantId).catch(() => []);
            (active || []).forEach((lid) => membership.add(lid));
          }
          // `prechecked` from the caller is a UX hint for the initial UI
          // state — used by the empty-heart single-list flow to pre-tick
          // the sole list so Save is one click. When provided, it drives
          // `checked`; otherwise we mirror actual membership.
          const uiHint = new Set(this.context.prechecked);
          const useUiHint = uiHint.size > 0;
          this.lists = (rawLists || []).map((l) => ({
            lid: l.lid,
            lname: l.lname,
            cnt: l.cnt || (Array.isArray(l.listcontents) ? l.listcontents.length : 0),
            checked: useUiHint ? uiHint.has(l.lid) : membership.has(l.lid),
            initialChecked: membership.has(l.lid),
          }));
        } catch (err) {
          console.warn('[wishlist-picker] fetch failed:', err);
          this.lists = [];
        } finally {
          this.loading = false;
        }
      },
      // Local-only toggle — no network. The CTA below stages changes and
      // fires them on click.
      toggle(list) {
        list.checked = !list.checked;
      },
      async commitSelection() {
        if (this.saving) return;
        if (!this.context || !this.context.variantId) return;
        const toAdd = this.lists.filter((l) => l.checked && !l.initialChecked);
        const toRemove = this.lists.filter((l) => !l.checked && l.initialChecked);
        if (toAdd.length === 0 && toRemove.length === 0) {
          // Nothing changed — treat as a benign close.
          this.close();
          return;
        }
        this.saving = true;
        const item = {
          dt: this.context.title,
          vi: this.context.variantTitle,
          iu: this.context.image,
          pr: this.context.price,
          du: this.context.url,
          epi: this.context.variantId,
          empi: this.context.productId,
        };
        try {
          for (const list of toAdd) {
            try {
              await window.EckList.addProduct(list.lid, this.context);
              list.initialChecked = true;
              // At least one add landed this session — a cart line opened
              // for save-for-later may now be moved on close.
              this.didAdd = true;
              document.dispatchEvent(new CustomEvent('wishlist:toast', {
                detail: {
                  variantId: this.context.variantId,
                  productId: this.context.productId,
                  url: this.context.url,
                  lid: list.lid,
                  lname: list.lname,
                  kind: 'added',
                  item,
                },
                bubbles: true,
              }));
            } catch (err) {
              console.warn('[wishlist-picker] add to', list.lid, 'failed:', err);
            }
          }
          for (const list of toRemove) {
            try {
              await window.EckList.removeProduct(list.lid, this.context);
              list.initialChecked = false;
              document.dispatchEvent(new CustomEvent('wishlist:toast', {
                detail: {
                  variantId: this.context.variantId,
                  productId: this.context.productId,
                  url: this.context.url,
                  lid: list.lid,
                  lname: list.lname,
                  kind: 'removed',
                  item,
                },
                bubbles: true,
              }));
            } catch (err) {
              console.warn('[wishlist-picker] remove from', list.lid, 'failed:', err);
            }
          }
          this.close();
        } finally {
          this.saving = false;
        }
      },
      close() {
        const dialog = document.getElementById('wishlist-picker-drawer');
        if (dialog && typeof dialog.close === 'function') dialog.close();
      },
      openCreate() {
        const dialog = document.getElementById('wishlist-picker-drawer');
        if (dialog && typeof dialog.close === 'function') dialog.close();
        // `returnTo` lets the create drawer offer a Back button that reopens
        // this picker with the same product context.
        document.dispatchEvent(new CustomEvent('wishlist:open-create', {
          detail: { ...(this.context || {}), returnTo: 'picker' },
          bubbles: true,
        }));
      },
      // Cart save-for-later "move": run once on close, only after an add.
      // Bound to the dialog's native `close` event so every close path
      // (Save, header X, Esc) triggers it. A picker opened from the PDP
      // carries no `cartLineKey`, so this is a no-op there.
      async handleDrawerClose() {
        const ctx = this.context;
        if (!ctx || !ctx.cartLineKey || !ctx.saveForLater) return;
        if (!this.didAdd || this.moved) return;
        this.moved = true;
        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: String(ctx.cartLineKey), quantity: 0 }),
          });
          if (!res.ok) throw new Error('cart-change failed');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (err) {
          console.warn('[wishlist-picker] save-for-later move failed:', err);
        }
      },
      init() {
        this.hydrateLabels();
        const onOpen = (event) => this.open(event);
        document.addEventListener('wishlist:open-picker', onOpen);
        const dialog = document.getElementById('wishlist-picker-drawer');
        const onClose = () => this.handleDrawerClose();
        if (dialog) dialog.addEventListener('close', onClose);
        this.handlers = { onOpen, onClose, dialog };
      },
      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('wishlist:open-picker', this.handlers.onOpen);
        if (this.handlers.dialog) this.handlers.dialog.removeEventListener('close', this.handlers.onClose);
        this.handlers = null;
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-remove-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('wishlistRemoveButton', () => ({
      pending: false,
      unavailable: false,
      handlers: null,
      readAttrs() {
        const btn = this.$root;
        const priceStr = btn.dataset.wishlistProductPrice || '';
        const price = priceStr ? Number(priceStr) : null;
        return {
          lid: btn.dataset.wishlistLid,
          variantId: Number(btn.dataset.wishlistVariantId),
          productId: Number(btn.dataset.wishlistProductId),
          url: btn.dataset.wishlistProductUrl,
          title: btn.dataset.wishlistProductTitle || '',
          variantTitle: btn.dataset.wishlistVariantTitle || '',
          image: btn.dataset.wishlistProductImage || '',
          price: Number.isFinite(price) ? price : null,
        };
      },
      async onClick() {
        if (this.pending || this.unavailable) return;
        if (!window.EckList) return;
        const attrs = this.readAttrs();
        if (!attrs.lid || !attrs.variantId || !attrs.productId || !attrs.url) return;
        this.pending = true;
        try {
          await window.EckList.removeProduct(attrs.lid, {
            variantId: attrs.variantId,
            productId: attrs.productId,
            url: attrs.url,
          });
          document.dispatchEvent(new CustomEvent('wishlist:toast', {
            detail: {
              variantId: attrs.variantId,
              productId: attrs.productId,
              url: attrs.url,
              lid: attrs.lid,
              kind: 'removed',
              item: {
                dt: attrs.title,
                vi: attrs.variantTitle,
                iu: attrs.image,
                pr: attrs.price,
                du: attrs.url,
                epi: attrs.variantId,
                empi: attrs.productId,
              },
            },
            bubbles: true,
          }));
        } catch (err) {
          console.warn('[wishlist-remove-button] remove failed:', err);
        } finally {
          this.pending = false;
        }
      },
      init() {
        const onDegraded = () => { this.unavailable = true; };
        if (window.EckList && window.EckList.mode === 'degraded') onDegraded();
        document.addEventListener('swym:degraded', onDegraded);
        this.handlers = { onDegraded };
      },
      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('swym:degraded', this.handlers.onDegraded);
        this.handlers = null;
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-toast"] && !Shopify.designMode) return;
  try {
    (function () {
    let toastTimer = null;

    /* Resolve the suffix text for the current event. Templates carry
       a `__LNAME__` sentinel that we replace with the real list name
       at runtime; the *_generic variants have no sentinel and are
       used as a fallback when no list name was supplied. `origin`
       ('requisition' from the B2B save flows) swaps the generic
       fallback so it reads "requisition list" instead of "wishlist". */
    function suffixFor(toast, kind, lname, origin, isB2B) {
      const ds = toast.dataset;
      const listName = lname ? String(lname) : '';
      const isRequisition = origin === 'requisition' || isB2B;
      if (kind === 'removed') {
        if (listName && ds.removedSuffix) {
          return ds.removedSuffix.replace('__LNAME__', listName);
        }
        return (isRequisition ? ds.removedSuffixRequisitionGeneric : ds.removedSuffixGeneric) || '';
      }
      if (listName && ds.addedSuffix) {
        return ds.addedSuffix.replace('__LNAME__', listName);
      }
      return (isRequisition ? ds.addedSuffixRequisitionGeneric : ds.addedSuffixGeneric) || '';
    }

    function showWishlistToast(detail) {
      const toast = document.querySelector('[data-wishlist-toast]');
      if (!toast) return;
      // B2B customers use the requisition / quick-order list, so the toast
      // reads "requisition list" and its CTA points at /pages/quick-order.
      const toastIsB2B = toast.dataset.b2b === 'true';
      const titleNode = toast.querySelector('[data-wishlist-toast-title]');
      const suffixNode = toast.querySelector('[data-wishlist-toast-suffix]');
      const variantNode = toast.querySelector('[data-wishlist-toast-variant]');
      const imageNode = toast.querySelector('[data-wishlist-toast-image]');
      const thumbNode = toast.querySelector('.wishlist-toast__thumb');
      const item = detail.item || {};
      const productTitle = item.dt || item.product_title || item.title || 'Item';
      const variantTitle = item.vi || item.variant_title || '';
      const imageSrc = item.iu || item.image || (item.featured_image && item.featured_image.url);

      if (titleNode) titleNode.textContent = productTitle;
      if (suffixNode) suffixNode.textContent = suffixFor(toast, detail.kind, detail.lname, detail.origin, toastIsB2B);
      if (variantNode) {
        if (variantTitle) {
          variantNode.textContent = variantTitle;
          variantNode.hidden = false;
        } else {
          variantNode.textContent = '';
          variantNode.hidden = true;
        }
      }
      if (imageNode) {
        if (imageSrc) {
          imageNode.src = imageSrc;
          imageNode.alt = productTitle;
          toast.classList.remove('wishlist-toast--no-image');
          if (thumbNode) thumbNode.hidden = false;
        } else {
          // No image in the payload (the wishlist bridge doesn't round-trip
          // item metadata on removal). Hide the thumb and collapse the layout
          // rather than show an empty placeholder box.
          imageNode.removeAttribute('src');
          imageNode.alt = '';
          toast.classList.add('wishlist-toast--no-image');
          if (thumbNode) thumbNode.hidden = true;
        }
      }
      // Per-event CTA override — Quick Order dispatches this event with
      // a `View List` label + list url, wishlist actions leave both
      // blank and fall back to the default "View Wishlist" / /pages/wishlist.
      const ctaEl = toast.querySelector('.wishlist-toast__cta');
      if (ctaEl) {
        const ctaLabelEl = ctaEl.querySelector('.button__label') || ctaEl;
        const defaultLabel = ctaEl.dataset.defaultLabel || ctaLabelEl.textContent;
        const defaultHref = ctaEl.dataset.defaultHref || ctaEl.getAttribute('href') || '';
        ctaEl.dataset.defaultLabel = defaultLabel;
        ctaEl.dataset.defaultHref = defaultHref;
        if (detail.ctaLabel) {
          ctaLabelEl.textContent = detail.ctaLabel;
        } else if (toastIsB2B && toast.dataset.viewListLabel) {
          ctaLabelEl.textContent = toast.dataset.viewListLabel;
        } else {
          ctaLabelEl.textContent = defaultLabel;
        }
        if (detail.ctaUrl) {
          ctaEl.setAttribute('href', detail.ctaUrl);
        } else if (toastIsB2B) {
          const lid = detail.lid ? '?lid=' + encodeURIComponent(detail.lid) : '';
          ctaEl.setAttribute('href', '/pages/quick-order' + lid);
        } else {
          ctaEl.setAttribute('href', defaultHref);
        }
      }
      toast.setAttribute('data-active', '');
      toast.setAttribute('aria-hidden', 'false');
      // popover="manual" promotes the element into the top layer when
      // shown, so the toast sits above any open <dialog> backdrop.
      try {
        if (typeof toast.showPopover === 'function' && !toast.matches(':popover-open')) {
          toast.showPopover();
        }
      } catch (e) { /* older browsers fall back to plain z-index stacking */ }
      const delay = Number(toast.dataset.autoDismissMs) || 5000;
      if (toastTimer) window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(() => {
        toast.removeAttribute('data-active');
        toast.setAttribute('aria-hidden', 'true');
        try {
          if (typeof toast.hidePopover === 'function' && toast.matches(':popover-open')) {
            toast.hidePopover();
          }
        } catch (e) { /* ignore */ }
      }, delay);
    }

    document.addEventListener('wishlist:toast', (event) => {
      if (event && event.detail) showWishlistToast(event.detail);
    });

    /* Cart -> wishlist bridge. When a shopper clicks "Save for later"
       on a cart line, we (1) add the variant to their default list
       (creating "Favourites" if none exists), (2) remove the line
       from cart, and (3) surface a confirmation toast. Save-for-later
       is fire-and-forget; failures are logged and the cart line is
       left in place so the shopper can retry. */
    async function saveForLaterHandler(detail) {
      if (!window.EckList) return;
      const variantId = Number(detail.variantId);
      const productId = Number(detail.productId);
      const url = String(detail.url || '');
      const title = String(detail.title || '');
      const lineKey = detail.key;
      if (!variantId || !productId || !url || !lineKey) {
        console.warn('[wishlist-toast] save-for-later payload incomplete', detail);
        return;
      }
      try {
        const defaultList = await window.EckList.getDefaultList({ createIfMissing: 'Favourites' });
        if (!defaultList || !defaultList.lid) return;
        // Dedupe: only add if the variant isn't already in the default list.
        // Save-for-later is a "move" - the cart-remove still runs even if the
        // variant was already saved earlier.
        const alreadyInList = (defaultList.listcontents || []).some((it) => Number(it.epi) === variantId);
        if (!alreadyInList) {
          await window.EckList.addProduct(defaultList.lid, { variantId, productId, url });
        }
        const cartRes = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: String(lineKey), quantity: 0 }),
        });
        if (!cartRes.ok) throw new Error('cart-change failed');
        document.dispatchEvent(new CustomEvent('wishlist:toast', {
          detail: {
            kind: 'added',
            lid: defaultList.lid,
            lname: defaultList.lname,
            variantId, productId, url,
            item: { dt: title, du: url, epi: variantId, empi: productId },
          },
          bubbles: true,
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (err) {
        console.warn('[wishlist-toast] save-for-later failed:', err);
      }
    }

    document.addEventListener('cart-item:save-for-later', (event) => {
      if (event && event.detail) saveForLaterHandler(event.detail);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
